<template>
  <div class="row no-gutters body">
    <!-- <div class="col-12">
      <div class="row no-gutters header">
        <div class="col d-flex">
          <div class="col-lg-3 col-md-2 col-sm-1">
            <sidemenu class=" d-block d-sm-block d-md-block d-lg-none"></sidemenu>
            <div class="ml-5 mt-3 d-none d-lg-block" @click="gotoMainPage()">
              <img src="../assets/Logo.svg" />
            </div>
          </div>
          <div class="col-lg-9 ml-4  col-11 col-sm-12 topmenubar">
            <topmenu></topmenu>
          </div>
        </div>
      </div>
    </div> -->
    <div class="col-12 pb-5 mb-4" v-if="pageloader">
      <img src="../assets/pageloader.svg" class="pageloader" alt="loading">
    </div>
    <div class="col-12 middle-background main-card"  v-if="!pageloader">
      <div class="row no-gutters">
        <div class="col-lg-3 mt-5 middle-background createsidemenu">
          <div>
          <div class="mt-4 ml-lg-4 ml-md-0 d-flex justify-content-between col-lg-10">
            <div class="mt-5 pointer" @click="gotoMainPage">
              <img src="../assets/Back.svg" class="negmargin5" alt="back"/>
              <label class="ml-2 black fontsize20 proximanova-semibold pointer"> {{ (currentRoute=='createprofile') ? 'Create Profile' : 'Edit Profile' }}  </label>
            </div>
          </div>
          </div>
          <!-- sidemenu for large devices -->
          <nav class="navigation  mt-4 ml-2 mr-5 col-lg-10 d-none d-lg-block">
            <ul>
              <li class="border">
                <div class="mouseoveraction">
                  <a
                    data-toggle="collapse"
                    class="basic_info black80 fontsize16 proximanova-semibold"
                    :class="{'fontsize16 blue proximanova-semibold border-tab':activeClass == 'basic_info'}"
                    data-target="#faq1"
                    aria-expanded="true"
                    aria-controls="faq1"
                    id="basic_info"
                    @click="toggleActiveClass('basic_info')"
                  >Basic Information</a>
                </div>
                <div class="border-bottom"></div>
                <div class="mouseoveraction">
                  <div v-if="this.profileID!=null">
                    <a
                      data-toggle="collapse"
                      data-target="#faq2"
                      aria-expanded="true"
                      aria-controls="faq2"
                      class="contact_details black80 fontsize16 proximanova-semibold"
                      :class="{'fontsize16 blue proximanova-semibold border-tab':activeClass == 'contact_details'}"
                      id="contact_details"
                      @click="toggleActiveClass('contact_details')"
                    >Contact Details</a>
                  </div>
                  <div v-else>
                    <a
                      data-toggle="collapse"
                      class="black80 fontsize16 proximanova-semibold"
                      data-target="#faq1"
                      aria-expanded="true"
                      aria-controls="faq1"
                      id="basic_info"
                      @click="toggleActiveClass('basic_info')"
                    >Contact Details</a>
                  </div>
                    <!-- <a
                      data-toggle="collapse"
                      data-target="#faq2"
                      aria-expanded="true"
                      aria-controls="faq2"
                      class="list-Font-color"
                      :class="{'fontsize16 blue proximanova-semibold border-tab':activeClass == 'contact_details'}"
                      id="contact_details"
                      @click="toggleActiveClass('contact_details')"
                    >Contact Details</a> -->
                </div>
                  
                <div class="border-bottom"></div>
                <div class="mouseoveraction">
                  <div v-if="this.profileID!=null">
                    <a
                      data-toggle="collapse"
                      data-target="#faq3"
                      aria-expanded="true"
                      aria-controls="faq3"
                      class="work_exp black80 fontsize16 proximanova-semibold"
                      :class="{'fontsize16 blue proximanova-semibold border-tab':activeClass == 'work_exp'}"
                      id="work_exp"
                      @click="toggleActiveClass('work_exp')"
                    >Work Experience</a>
                  </div>
                  <div v-else>
                    <a
                      data-toggle="collapse"
                      class="black80 fontsize16 proximanova-semibold"
                      data-target="#faq1"
                      aria-expanded="true"
                      aria-controls="faq1"
                      id="basic_info"
                      @click="toggleActiveClass('basic_info')"
                    >Work Experience</a>
                  </div>
                </div>
                <div class="border-bottom"></div>
                <div class="mouseoveraction">
                  <div v-if="this.profileID!=null">
                    <a
                      data-toggle="collapse"
                      data-target="#faq4"
                      aria-expanded="true"
                      aria-controls="faq4"
                      class="education black80 fontsize16 proximanova-semibold"
                      :class="{'fontsize16 blue proximanova-semibold border-tab':activeClass == 'education'}"
                      id="education"
                      @click="toggleActiveClass('education')"
                    >Education/Certifications</a>
                  </div>
                  <div v-else>
                    <a
                      data-toggle="collapse"
                      class="black80 fontsize16 proximanova-semibold"
                      data-target="#faq1"
                      aria-expanded="true"
                      aria-controls="faq1"
                      id="basic_info"
                      @click="toggleActiveClass('basic_info')"
                    >Education/Certifications</a>
                  </div>
                </div>
                <div class="border-bottom"></div>
                <div class="mouseoveraction">
                  <div v-if="this.profileID!=null">
                    <a
                      data-toggle="collapse"
                      data-target="#faq5"
                      aria-expanded="true"
                      aria-controls="faq5"
                      id="current_location"
                      class="current_location black80 fontsize16 proximanova-semibold"
                      :class="{'fontsize16 blue proximanova-semibold border-tab':activeClass == 'current_location'}"
                      @click="toggleActiveClass('current_location')"
                    >Current Location</a>
                  </div>
                  <div v-else>
                    <a
                      data-toggle="collapse"
                      class="black80 fontsize16 proximanova-semibold"
                      data-target="#faq1"
                      aria-expanded="true"
                      aria-controls="faq1"
                      id="basic_info"
                      @click="toggleActiveClass('basic_info')"
                    >Current Location</a>
                  </div>
                </div>
                <div class="border-bottom"></div>
                <div class="mouseoveraction">
                  <div v-if="this.profileID!=null">
                    <a
                      data-toggle="collapse"
                      data-target="#faq6"
                      aria-expanded="true"
                      class="skills black80 fontsize16 proximanova-semibold"
                      aria-controls="faq6"
                      :class="{'fontsize16 blue proximanova-semibold border-tab':activeClass == 'skills'}"
                      id="skills"
                      @click="toggleActiveClass('skills')"
                    >Skills</a>
                  </div>
                  <div v-else>
                    <a
                      data-toggle="collapse"
                      class="black80 fontsize16 proximanova-semibold"
                      data-target="#faq1"
                      aria-expanded="true"
                      aria-controls="faq1"
                      id="basic_info"
                      @click="toggleActiveClass('basic_info')"
                    >Skills</a>
                  </div>
                </div>
              </li>
            </ul>
          </nav>
        </div>
        
        <div class="col-md-12 col-lg-6 pb-5 mb-4 middle-background centercard">
          <div class="row no-gutters">
            <br />
          </div>
          <div id="main">
            <!-- horizontal srrollable menu for small and medium devices -->
            <div class="col ml-sm-1 pr-md-2 ml-md-2 no-gutters d-block d-lg-none horizontmenu">
              <div class="nav nav-tabs p-2 font12-boldcolor d-flex flex-nowrap  border rounded mobviewItems">
                <div class="nav-item">
                <a
                    data-toggle="collapse"
                    class="flex-nowrap basic_info black80 fontsize16 proximanova-semibold"
                    :class="{'fontsize16 blue proximanova-semibold border-tab-bottom':activeClass == 'basic_info'}"
                    data-target="#faq1"
                    aria-expanded="true"
                    aria-controls="faq1"
                    id="basic_info"
                    @click="toggleActiveClass('basic_info')"

                  >Basic Information</a>
                </div>
                <p class="mr-2 ml-2">|</p>
                <div class="nav-item">
                  <a
                    data-toggle="collapse"
                    data-target="#faq2"
                    aria-expanded="true"
                    aria-controls="faq2"
                    class="flex-nowrap basic_info black80 fontsize16 proximanova-semibold"
                    :class="{'fontsize16 blue proximanova-semibold border-tab-bottom':activeClass == 'contact_details'}"
                    id="contact_details"
                    @click="toggleActiveClass('contact_details')"
                  >Contact Details</a>
                </div>
                <p class="mr-2 ml-2">|</p>
                <div class="nav-item">
                  <a
                    data-toggle="collapse"
                    data-target="#faq3"
                    aria-expanded="true"
                    aria-controls="faq3"
                    class="flex-nowrap basic_info black80 fontsize16 proximanova-semibold"
                    :class="{'fontsize16 blue proximanova-semibold border-tab-bottom':activeClass == 'work_exp'}"
                    id="work_exp"
                    @click="toggleActiveClass('work_exp')"
                  >Work Experience</a>

                </div>
                <p class="mr-2 ml-2">|</p>
                <div class="nav-item">
                  <a
                    data-toggle="collapse"
                    data-target="#faq4"
                    aria-expanded="true"
                    aria-controls="faq4"
                    class="flex-nowrap basic_info black80 fontsize16 proximanova-semibold"
                    :class="{'fontsize16 blue proximanova-semibold border-tab-bottom':activeClass == 'education'}"
                    id="education"
                    @click="toggleActiveClass('education')"
                  >Education/Certifications</a>
                </div>
                <p class="mr-2 ml-2">|</p>
                <div class="nav-item">
                  <a
                    data-toggle="collapse"
                    data-target="#faq5"
                    aria-expanded="true"
                    aria-controls="faq5"
                    id="current_location"
                    class="flex-nowrap basic_info black80 fontsize16 proximanova-semibold"
                    :class="{'fontsize16 blue proximanova-semibold border-tab-bottom':activeClass == 'current_location'}"
                    @click="toggleActiveClass('current_location')"
                  >Current Location</a>
                </div>
                <p class="mr-2 ml-2">|</p>
                <div class="nav-item pr-3">
                  <a
                    data-toggle="collapse"
                    data-target="#faq6"
                    aria-expanded="true"
                    class="flex-nowrap basic_info black80 fontsize16 proximanova-semibold"
                    aria-controls="faq6"
                    :class="{'fontsize16 blue proximanova-semibold border-tab-bottom':activeClass == 'skills'}"
                    id="skills"
                    @click="toggleActiveClass('skills')"
                  >Skills</a>
                </div>
              </div>
            </div>
            <div>
              <div class="row no-gutters">
                <br/>
              </div>
              <div class="accordion" id="faq">
                <div class="row no-gutters ml-3 mr-3 ml-md-4 mr-lg-1 mb-3">
                        <div class="col-12">
                          <!-- basic Information section -->
                          <!-- user can able to add basic Information and also profile picture -->
                <div class="card mt-lg-5 mt-md-3 mt-sm-1">
                  <div class="card-header" id="faqhead1">
                    <a
                      class="btn btn-header-link proximanova-semibold"
                      data-toggle="collapse"
                      data-target="#faq1"
                      aria-expanded="true"
                      aria-controls="faq1"
                      @click="toggleActiveClass('basic_info')"
                    >Basic Information</a>
                  </div>

                  <div
                    id="faq1"
                    class="collapse show"
                    aria-labelledby="faqhead1"
                    data-parent="#faq"
                  >
                  <div class="">
                    <div class="row no-gutters  ">
                      <div class="col d-flex ml-4 mt-5">
                       
                         <div v-if="this.profilePicLink=='' || this.profilePicLink == undefined">   
                          <img class="img-fluid" alt="profilepic" src="../assets/AddProfile.svg" @click="imageModalOpen" data-toggle="modal" data-target="#exampleModal"/>
                         </div>
                         <div v-else class="profile-pic">
                           <div class="profile-border ">
                             <img :src="this.profilePicLink" alt="profilepic" oncontextmenu="return false" class="photo" >
                           </div>
                           <img src="../assets/Edit.svg" alt="edit" title="Edit Profile picture" @click="imageModalOpen"  class="img-circle edit" data-toggle="modal" data-target="#exampleModal">
                         </div>
                      </div>
                      <img  style="float:right" alt="profilepic" src="../assets/ProfileImages.svg"  class="mt-5 profimg"/>
                    </div>
                  </div>
                    <div class="card-body">
                      <div class="form">

                        <div class="row no-gutters mb-3">
                          <div class="col-12 d-md-flex justify-content-start align-items-center">
                            <div class="col-lg-6 col-md-6 col-sm-12">
                              <div class="input-group">
                                <input
                                  type="text"
                                  v-validate=" 'required' "
                                  name="First Name"
                                  data-vv-as="First Name"
                                  data-vv-scope="addBasicinfo"
                                  class="input-create"
                                  v-model.trim="firstname"
                                  autocomplete="nope"
                                  maxlength="20"
                                  @keypress="allowOnlyNumbersandCharacters"
                                  @keyup="checkfornumbersanddigits"
                                  required
                                />
                                <span class="bar"></span>
                                <label class="label-create required">First Name</label>

                              </div>
                              <div v-if="errors.has('addBasicinfo.First Name')" class="alert-danger">{{ errors.first('addBasicinfo.First Name') }}</div>
                              <div v-if="!validfirstname" class="alert-danger">First Name shouldn't contains numbers and symbols</div>
                            </div>

                            <div class="col-lg-6 col-md-6 col-sm-12 pt-3 pt-md-0">
                              <div class="input-group">
                                <input
                                  type="text"
                                  v-validate=" 'required' "
                                  name="Last Name"
                                  data-vv-as="Last Name"
                                  data-vv-scope="addBasicinfo"
                                  autocomplete="nope"
                                  class="input-create"
                                  v-model="lastname"
                                  maxlength="20"
                                  @keypress="allowOnlyNumbersandCharacters"
                                  @keyup="checkfornumbersanddigits"
                                  required
                                />
                                <span class="bar"></span>
                                <label class="label-create required">Last Name</label>
                              </div>
                              <div v-if="errors.has('addBasicinfo.Last Name')" class="alert-danger ml-1">{{ errors.first('addBasicinfo.Last Name') }}</div>
                              <div v-if="!validlastname" class="alert-danger">Last Name shouldn't contains numbers and symbols</div>
                            </div>
                          </div>
                           <!-- <div class="col-12 d-flex ml-2">
                                  <div
                                    v-if="errors.has('addBasicinfo.First Name')"
                                    class="alert-danger col-6"
                                  >{{ errors.first('addBasicinfo.First Name') }}</div>
                                  <div
                                    v-else
                                    class="alert-danger col-6"
                                  ></div>
                                  <div
                                    v-if="errors.has('addBasicinfo.Last Name')"
                                    class="alert-danger col-6 ml-1"
                                  >{{ errors.first('addBasicinfo.Last Name') }}</div>
                           </div> -->

                        </div>
                        <div class="row no-gutters mb-3">
                          <div class="col-12 d-md-flex justify-content-start align-items-center">
                            <div class="col-lg-6 col-md-6 col-sm-12">
                              <div class="input-group pt-lg-0 mt-lg-1">
                                <small class="required small-label">Gender</small>
                                <select
                                  type="text"
                                  v-validate=" 'required' "
                                  name="Gender"
                                  data-vv-as="Gender"
                                  data-vv-scope="addBasicinfo"
                                  class="input-create"
                                  onclick="this.setAttribute('value', this.value);"
                                  v-model="gender"
                                  required
                                >
                                  <option
                                    v-for="(gender,index) in genderList"
                                    :value="gender.id"
                                    :key="index"
                                  >{{gender.indexDetailName}}</option>
                                </select>
                                <span class="bar"></span>
                                <!-- <label class="label-create required">Gender</label> -->

                              </div>
                              <div v-if="errors.has('addBasicinfo.Gender')" class="alert-danger">{{ errors.first('addBasicinfo.Gender') }}</div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12">
                                <div class="input-group">
                                  <small class="required small-label mt-2 mt-md-0">Date Of Birth (MM/DD/YYYY)</small>
                                  <!-- <input
                                    type="date"
                                    name="DateofBirth"

                                    data-vv-as="DateofBirth"
                                    data-vv-scope="addBasicinfo"
                                    @change="dateOfBirthValidation"
                                    class="input-create dob"
                                    id="birthDate"
                                    v-model="birthDate"
                                    required
                                  /> -->
                                  <date-picker 
                                    v-model="birthDate" 
                                    class="input-create dob" 
                                    name="DateofBirth"
                                    data-vv-as="DateofBirth"
                                    id="birthDate"
                                    data-vv-scope="addBasicinfo"
                                    @change="dateOfBirthValidation" 
                                    format="MM/DD/YYYY"
                                    valueType="format"
                                    required
                                  ></date-picker>
                                  <span class="bar"></span>
                                  <!-- <label class="label-create required">Date Of Birth</label> -->

                                </div>
                                <div v-if="errors.has('addBasicinfo.DateofBirth')" class="alert-danger">{{ errors.first('addBasicinfo.DateofBirth') }}</div>
                                <div v-if="this.incorrectDOB!=''" class="alert-danger">{{incorrectDOB}}</div>
                              </div>
                          </div>
                          <!-- <div class="col-12 d-flex ml-2">
                                  <div
                                   v-if="errors.has('addBasicinfo.Gender')"
                                    class="alert-danger col-6"
                                  >{{ errors.first('addBasicinfo.Gender') }}</div>
                                  <div
                                    v-else
                                    class="alert-danger col-6"
                                  ></div>
                                   <div
                                   v-if="errors.has('addBasicinfo.DateofBirth')"
                                    class="alert-danger col-6"
                                  >{{ errors.first('addBasicinfo.DateofBirth') }}</div>
                                  <div v-if="this.incorrectDOB!=''" class="alert-danger col-6">
                                    {{incorrectDOB}}

                                  </div>

                           </div> -->
                        </div>


                      </div>
                      <div class="row no-gutters mb-3">
                        <div class="col-12 d-md-flex justify-content-start align-items-center">
                          <div class="col-lg-6 col-md-6 col-sm-12">
                            <div class="input-group ">
                              <input
                                type="text"
                                name="Company"
                                data-vv-as="Company"
                                class="input-create"
                                v-model="companyname"
                                autocomplete="off"
                                v-validate=" 'required' "
                                data-vv-scope="addBasicinfo"
                                @keyup="checkBasicCompany()"
                                required
                              />
                              <span class="bar"></span>
                              <label class="label-create required">Company / College</label>

                              <!-- <div class="searchResults text-center w-100">
                              <ul id="basicinfocompany">
                                <li class="border"
                                  v-for="(company,index) in basicCompanyList"
                                  :value="company.id"
                                  :key="index"
                                  @click="addCompany(company.companyName,company.id)"
                                >{{company.companyName}}</li>
                              </ul>
                              </div> -->
                              <div class="dropdown-menu col-10 d-flex" id="LocationDropdown" v-if="basicCompanyList.length > 0"> 
                                    <div class="fontsize12 col-12 pl-0 pr-0 black60 proximanova pointer">
                                      <li class="list-group-item pl-3" :value="company.id" v-for="(company,i) in basicCompanyList" :key="i" 
                                      @click="addCompany(company.companyName,company.id)">
                                        {{company.companyName}}
                                      </li>
                                    </div>
                                  </div>
                            </div>
                            <div v-if="errors.has('addBasicinfo.Company') && !companyname" class="alert-danger">{{ errors.first('addBasicinfo.Company') }}</div>
                            <div v-if="!validcompanyname" class="alert-danger">Company Name shouldn't start with special characters</div>
                          </div>
                          <div class="col-lg-6 col-md-6 col-sm-12 pt-3 pt-md-0">
                            <div class="input-group">
                              <input
                                type="text"
                                name="Designation"
                                data-vv-as="Designation"
                                class="input-create"
                                v-validate=" 'required' "
                                data-vv-scope="addBasicinfo"
                                autocomplete="off"
                                @keyup="checkBasicDesignation()"
                                v-model="designation"
                                required
                              />
                              <span class="bar"></span>
                              <label class="label-create required">Designation / Education</label>

                              <!-- <ul id="basicinfoDesignation" class="searchResults text-center w-100">
                                <li class="border"
                                  v-for="(designation,index) in basicDesignationList"
                                  :value="designation.id"
                                  :key="index"
                                  @click="addDesignation(designation.roleName,designation.id)"
                                >{{designation.roleName}}</li>
                              </ul> -->
                              <div class="dropdown-menu col-10 d-flex" id="LocationDropdown" v-if="basicDesignationList.length > 0"> 
                                    <div class="fontsize12 col-12 pl-0 pr-0 black60 proximanova pointer">
                                      <li class="list-group-item pl-3" :value="designation.id" v-for="(designation,index) in basicDesignationList" :key="index" 
                                      @click="addDesignation(designation.roleName,designation.id)">
                                        {{designation.roleName}}
                                      </li>
                                    </div>
                                  </div>
                            </div>
                            <div v-if="errors.has('addBasicinfo.Designation')" class="alert-danger ml-2">{{ errors.first('addBasicinfo.Designation') }}</div>
                            <div v-if="!validdesignation" class="alert-danger">Designation shouldn't start with special characters</div>
                          </div>
                        </div>
                        <!-- <div class="col-12 d-flex ml-2">
                                  <div
                                    v-if="errors.has('addBasicinfo.Company')"
                                    class="alert-danger col-6"
                                  >{{ errors.first('addBasicinfo.Company') }}</div>
                                  <div
                                    v-else
                                    class="alert-danger col-6"
                                  ></div>

                                  <div
                                    v-if="errors.has('addBasicinfo.Designation')"
                                    class="alert-danger col-6 ml-2"
                                  >{{ errors.first('addBasicinfo.Designation') }}</div>

                                </div> -->
                      </div>
                      <div class="row no-gutters mb-3">
                        <div class="col-12 justify-content-start align-items-center">
                          <div class="col-lg-6 d-flex col-md-6 col-sm-12">
                            <div class="col-1 prifixusernameinput">
                              <input
                                type="text"
                                name="prifixusername"
                                data-vv-as="prifixusername"
                                class="input-create proximanova-bold pr-0"
                                v-model="prifixusername"
                                autocomplete="off"
                                disabled
                              />
                              <span class="bar"></span>
                            </div>
                            <div class="input-group col-11 pl-0 pr-0">
                              <input
                                type="text"
                                name="username"
                                data-vv-as="username"
                                class="input-create"
                                v-model="username"
                                autocomplete="off"
                                v-validate=" 'required' "
                                data-vv-scope="addBasicinfo" 
                                @keyup="checkusername()"
                                required
                              />
                              <span class="bar"></span>
                              <label class="label-create required">User name</label>
                            </div>
                          </div>
                          <div v-if="errors.has('addBasicinfo.username') && !username" class="alert-danger ml-3">{{ errors.first('addBasicinfo.username') }}</div>
                          <div v-if="usernamerror" class="alert-danger ml-3">{{usernamerror}}</div>
                        </div>
                      </div>
                      <div class="row no-gutters ml-3">
                        <div class="col-12 d-flex justify-content-start align-items-center ">
                          <div class="form-group">
                            <label for="exampleFormControlTextarea1" class="proximanova">About You (optional) <div class="d-flex">(<p id="charactersRemaining">140</p><p>/140 )</p></div></label>
                            <textarea
                              class="form-control proximanova"
                              v-model="aboutYou"
                              id="exampleFormControlTextarea1"
                               @keyup="calculateTextAreaCount()"
                              rows="5"
                              cols="77"
                              spellcheck="true"
                              maxlength="140"
                            ></textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="card-footer collapse show"
                    id="faq1"
                    aria-labelledby="faqhead1"
                    data-parent="#faq"
                  >
                    <div class="float-right">
                      <button class="mr-3 btn rounded button-cancel1" @click="navigateToUserProfile">
                        <span class="proximanova">Cancel</span>
                      </button>
                      <button v-show="create" v-on:click="saveBasicInformation" :disabled="basicinfo" class="btn backgroundcolorblack button-create sign-up-button borderradius20" id="basicinfo">
                        <span class="button-create-font proximanova">{{ (currentRoute=='createprofile') ? "Create" : "Save" }}</span>
                      </button>
                      <button v-show="!create" v-on:click="saveBasicInformation" :disabled="basicinfo" class="btn backgroundcolorblack button-create proximanova mouseoverbtn2 borderradius20" id="basicinfo1">
                        <span>Save</span>
                      </button>
                    </div>
                  </div>
                </div>
                        </div>
                </div>
                <div class="row no-gutters ml-3 mr-3 ml-md-4 mr-lg-1 mb-3">
                        <div class="col-12">
                          <!-- contact details section -->
                <div class="card">
                  <div class="card-header" id="faqhead2">
                    <div v-if="this.profileID!=null">
                    <a
                      class="btn btn-header-link collapsed proximanova-semibold"
                      data-toggle="collapse"
                      data-target="#faq2"
                      aria-expanded="true"
                      aria-controls="faq2"
                      @click="toggleActiveClass('contact_details')"
                    >Contact Details</a>
                    </div>
                    <div v-else>
                    <a
                      class="btn btn-header-link collapsed proximanova-semibold"
                      data-toggle="collapse show"
                      data-target="#faq1"
                      aria-expanded="true"
                      aria-controls="faq1"
                    >Contact Details</a>
                    </div>
                  </div>

                  <div id="faq2" class="collapse" aria-labelledby="faqhead2" data-parent="#faq">
                    <div class="card-body">
                      <div class="form">
                        <div class="row no-gutters">
                          <div class="col d-flex justify-content-start align-items-center">
                            <div class="col-lg-6 col-sm-12">
                              <div class="input-group mb-3">
                                <input
                                  type="email"
                                  v-validate=" 'required' "
                                  name="Email"
                                  data-vv-as="Email"
                                   data-vv-scope="addContact"
                                   autocomplete="off"
                                  class="input-create"
                                  v-model="email"
                                  disabled
                                  required
                                />
                                <span class="bar"></span>

                                <center>
                                  <div
                                    v-if="errors.has('addContact.Email')"
                                    class="alert-danger"
                                  >{{ errors.first('addContact.Email') }}</div>
                                </center>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row d-flex no-gutters mb-3">
                          <div class="col-lg-6 d-flex justify-content-start align-items-center ">
                            <div class="col-lg-12 col-sm-12">
                              <div class="col pl-0 pr-0 d-flex mt-2">
                                  <div class="col-4 countryCodeInput ">
                                    <select
                                      type="text"
                                      name="comapnySize"
                                      data-vv-as="comapnySize"
                                      data-vv-scope="aboutUs"
                                      class="input-create countryCodeInputfield mt-1"
                                      onclick="this.setAttribute('value', this.value);"
                                      v-model="primaryCountryCode"
                                      required
                                    >
                                      <option
                                        v-for="(cc,index) in countyCodesList"
                                        :value="cc.countryCode"
                                        :key="index"
                                      >{{cc.countryName}}({{cc.countryCode}})</option>
                                    </select>
                                  </div>
                                  <div class="col-8 input-group pr-0">
                                    <input
                                      type="text"
                                      name="Mobile Number"
                                      v-validate="'required|min:10|max:14'"
                                      @input="formatCellPhoneNumber"
                                      @blur="formatCellPhoneNumber"
                                    
                                      data-vv-as="Primary Mobile Number"
                                      data-vv-scope="addContact"
                                      class="input-create"
                                      autocomplete="off"
                                      maxlength="10"
                                      v-model="primaryMobileNumber"
                                      required
                                    />
                                    <span class="bar"></span>
                                    <label class="label-create required ml-2">Primary Mobile Number</label>
                                  </div>
                              </div>
                              <div v-if="errors.has('addContact.Mobile Number')"
                                class="alert-danger"
                                >{{ errors.first('addContact.Mobile Number') }}
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-6 pt-2 pt-md-0 d-flex justify-content-start align-items-center">
                              <div class="col-12 col-sm-12">
                                <div class="col pl-0 pr-0 d-flex mt-2">
                                  <div class="col-4 countryCodeInput ">
                                    <select
                                        type="text"
                                        name="comapnySize"
                                        data-vv-as="comapnySize"
                                        data-vv-scope="aboutUs"
                                        class="input-create countryCodeInputfield mt-1"
                                        onclick="this.setAttribute('value', this.value);"
                                        v-model="alternateCountryCode"
                                        required
                                    >
                                      <option
                                          v-for="(cc,index) in countyCodesList"
                                          :value="cc.countryCode"
                                          :key="index"
                                      >{{cc.countryName}}({{cc.countryCode}})</option>
                                    </select>
                                  </div>
                                  <div class="input-group col-8 pr-0">
                                    <input
                                      type="text"
                                      name="Mobile Number"
                                      data-vv-as="Alternate Mobile Number"
                                      v-validate="'required|min:10|max:14'"
                                      @input="formatCellPhoneNumber"
                                      @blur="formatCellPhoneNumber"
                                      class="input-create"
                                      autocomplete="off"
                                      maxlength="10"
                                      v-model="alternateMobileNumber"
                                      required
                                    />
                                    <span class="bar"></span>
                                    <label class="label-create ml-2">Alternate Mobile Number</label>
                                  </div>
                                </div>
                              </div>
                          </div>
                        </div>
                        <div class="row no-gutters">
                          <div class="col d-flex justify-content-start align-items-center">
                            <div class="col-12">
                              <div class="input-group mb-3">
                                <input
                                  type="text"
                                  name="Mobile Number"
                                  data-vv-as="Primary Mobile Number"
                                  class="input-create"
                                  v-model="websiteUrl"
                                  required
                                />
                                <span class="bar"></span>
                                <label class="label-create">Website / Potfolio URL</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="card-footer collapse"
                    id="faq2"
                    aria-labelledby="faqhead2"
                    data-parent="#faq"
                  >
                    <div class="float-right">
                      <button class="mr-3 btn button-cancel1" @click="navigateToUserProfile">
                        <span class="proximanova">Cancel</span>
                      </button>
                      <button v-show="createcontact" class="mr-3 btn backgroundcolorblack button-create sign-up-button borderradius20" :disabled="contactinfo" id= "contactdetails" v-on:click="saveContactDetails">
                        <span class="button-create-font proximanova">{{ (currentRoute=='createprofile') ? "Create" : "Save" }}</span>
                      </button>
                      <button v-show="!createcontact" class="mr-3 btn backgroundcolorblack button-create mouseoverbtn2 borderradius20" :disabled="contactinfo" id= "contactdetails1" v-on:click="saveContactDetails">
                        <span class="button-cancel-font proximanova">Save</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row no-gutters ml-3 mr-3 ml-md-4 mr-lg-1 mb-3">
                        <div class="col-12">
                          <!-- work experirnce section -->
                          <!-- user can able to add multiple work experieneces -->
                <div class="card">
                  <div class="card-header" id="faqhead3">
                    <div v-if="this.profileID!=null">
                    <a
                      class="btn btn-header-link collapsed proximanova-semibold"
                      data-toggle="collapse"
                      data-target="#faq3"
                      aria-expanded="true"
                      aria-controls="faq3"
                      @click="toggleActiveClass('work_exp')"
                    >Work Experience</a>
                  </div>
                  <div v-else>
                    <a
                      class="btn btn-header-link collapsed proximanova-semibold"
                      data-toggle="collapse show"
                      data-target="#faq1"
                      aria-expanded="true"
                      aria-controls="faq1"
                    >Work Experience</a>
                    </div>
                  </div>

                  <div id="faq3" class="collapse" aria-labelledby="faqhead3" data-parent="#faq">
                    <div class="experience" v-for="(expobj, index) in experience" :key="index">
                        <div class="exp pt-3 pb-3 border">
                          <div class="col-12 experiences pl-0">
                            <div class="d-flex justify-content-between">
                                <div class="col-9 col-md-8">
                                  <div class="d-flex ml-1">
                                    <img src="../assets/Company_Icon.svg" alt="companyicon" class="img-fluid rounded-circle">
                                    <div class="ml-1 flex-nowrap proximanova-bold fontsize14 black text-capitalize"> {{expobj.company}}</div>
                                  </div>
                                  <div class="flex-nowrap pl-4 ml-2 proximanova fontsize14 black80 text-capitalize">
                                    <div>{{expobj.roleName}}</div>
                                  </div>
                                </div>
                                <div class="d-flex mr-lg-2 mr-sm-1 justify-content-between">
                                  <div class="d-flex mr-lg-2 mr-sm-1 pointer" @click="editExperience(index)">
                                    <img src="../assets/Edit.svg" alt="edit" style="width:26px">
                                    <div class="ml-1 d-none d-lg-block my-auto fontsize14 proximanova" style="vertical-align:middle">Edit</div>
                                  </div>
                                  <div class="d-flex ml-2 pointer" @click="deleteExperienceModal(index)" data-toggle="modal" data-target="#deleteExpModal">
                                    <img src="../assets/Deleteall.svg" alt="delete" style="width:28px">
                                    <div class="ml-1 d-none d-lg-block my-auto fontsize14 proximanova">Delete</div>
                                  </div>
                                  <div class="modal fade" id="deleteExpModal" tabindex="-1" role="dialog" aria-labelledby="deleteExpModalLabel" aria-hidden="true">
                                      <div class="modal-dialog " role="document">
                                        <div class="modal-content">
                                          <div class="modal-header delete-modal pb-0">
                                            <h5 class="modal-title fontsize20 black80 proximanova" id="deleteExpModalLabel">Are you sure you want to delete this record ?</h5>
                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="clearSelectedIndex">
                                              <span aria-hidden="true">&times;</span>
                                            </button>
                                          </div>
                                          <div class="modal-body modal-delete text-center mt-2">
                                            <span class="button-cancel-font modaldeletebtn border rounded p-2 pr-4 pl-4 proximanova" data-dismiss="modal" aria-label="Close" @click="clearSelectedIndex">No</span>
                                            <span class="button-cancel-font backgroundcolorblack border p-2 ml-2 pr-4 pl-4 rounded proximanova" @click="deleteExperience(index)">Yes</span>
                                          </div>
                                        </div>
                                      </div>
                                  </div>
                                </div>
                            </div>
                          </div>
                        </div>
                    </div>
                    <div class="card-body">
                      <div v-if="duplicateFlag" class="text-center"><span class="duplicateError proximanova">Duplicate records existed. plese check your Data.</span></div>
                        <div class="alert-danger  ml-1 text-center">{{AddErrorMessage}}</div>
                        <div class="form" v-if="hidedisplayexperienceInput">
                          <div class="row no-gutters mb-3">
                            <div class="col d-md-flex justify-content-start align-items-center ml-lg-2 ml-md-2">
                              <div class="col-lg-6 col-md-6 col-sm-12 exppadding">
                                <div class="input-group">
                                  <input
                                    type="text"
                                    data-vv-as="Company"
                                    data-vv-scope="exp"
                                    :name="'expcompany'"
                                    class="input-create"
                                    id="workCompany"
                                    @keyup="checkexperiencecompany()"
                                    autocomplete="off"
                                    v-model="exp.company"
                                    v-validate=" 'required' "
                                    required
                                  />
                                  <span class="bar"></span>
                                  <label class="label-create required">Company</label>
                                  <!-- <ul class="searchResults text-center w-100">
                                    <li class="border"
                                      v-for="(company,i) in companyList"
                                      :value="company.id"
                                      :key="i"
                                      @click="addexperienceOfCompany(company.companyName,i,company.id)"
                                    >{{company.companyName}}</li>
                                  </ul> -->
                                  <div class="dropdown-menu col-10 d-flex" id="LocationDropdown" v-if="companyList.length > 0"> 
                                    <div class="fontsize12 col-12 pl-0 pr-0 black60 proximanova pointer">
                                      <li class="list-group-item pl-3" :value="company.id" v-for="(company,i) in companyList" :key="i" 
                                      @click="addexperienceOfCompany(company.companyName,i,company.id)">
                                        {{company.companyName}}
                                      </li>
                                    </div>
                                  </div>
                                </div>
                                <div v-if="errors.has('exp.expcompany')" class="alert-danger">{{ errors.first('exp.expcompany') }}</div>
                                <div v-if="!validexpcompanyname" class="alert-danger">Company Name shouldn't start with special characters</div>
                              </div>
                              <div class="col-lg-6 col-md-6 col-sm-12 exppadding pt-3 pt-md-0">
                                <div class="input-group">
                                  <input
                                    type="text"
                                    data-vv-as="Designation"
                                    data-vv-scope="exp"
                                    :name="'expdesignation'"
                                    class="input-create"
                                    id="compdesg"
                                    @keyup="checkexperiencedesignation()"
                                    autocomplete="off"
                                    v-model="exp.roleName"
                                    v-validate=" 'required' "
                                    required
                                  />
                                  <span class="bar"></span>
                                  <label class="label-create required">Designation</label>
                                  <!-- <ul :id="'workexpdesg'+index+''"  class="searchResults text-center w-100"> -->
                                  <!-- <ul  class="searchResults text-center w-100">
                                    <li class="border"
                                      v-for="(designation,i) in designationList"
                                      :value="designation.id"
                                      :key="i"
                                      @click="addexperienceDesignation(designation.roleName,i,designation.id)"
                                    >{{designation.roleName}}</li>
                                  </ul> -->
                                  <div class="dropdown-menu col-10 d-flex" id="LocationDropdown" v-if="designationList.length > 0"> 
                                    <div class="fontsize12 col-12 pl-0 pr-0 black60 proximanova pointer">
                                      <li class="list-group-item pl-3" :value="designation.id" v-for="(designation,i) in designationList" :key="i" @click="addexperienceDesignation(designation.roleName,i,designation.id)">
                                        {{designation.roleName}}
                                      </li>
                                    </div>
                                  </div>
                                </div>
                                <div v-if="errors.has('exp.expdesignation')" class="alert-danger">{{ errors.first('exp.expdesignation') }}</div>
                                <div v-if="!validexpdesignation" class="alert-danger">Designation shouldn't start with special characters</div>
                              </div>
                            </div>
                            <!-- <div class="col d-flex ml-lg-2 ml-md-2">

                                    <div
                                      v-if="errors.has('expcompany')"
                                      class="alert-danger col-6"
                                    >{{ errors.first('expcompany') }}</div>
                                    <div
                                      v-else
                                      class="alert-danger col-6"
                                    ></div>
                                    <div
                                      v-if="errors.has('expdesignation')"
                                      class="alert-danger col-6"
                                    >{{ errors.first('expdesignation') }}</div>


                            </div> -->
                          </div>
                          <div class="row no-gutters mb-3">
                            <div class="col d-md-flex justify-content-start align-items-center ml-lg-2 ml-md-2">
                              <div class="col-lg-6 col-md-6 col-sm-12 exppadding pt-2 pt-md-0 exppadding">
                                <div class="input-group mt-lg-3">
                                  <select
                                    type="text"
                                    v-validate=" 'required' "
                                    data-vv-as="Employment Type"
                                    :name="'expemploymentType'"
                                    data-vv-scope="exp"
                                    class="input-create"
                                    onclick="this.setAttribute('value', this.value);"
                                    v-model="exp.employmentType"
                                    required
                                  >
                                    <option
                                      v-for="(employmenttype,index) in employmentTypeList"
                                      v-bind:value="employmenttype.id"
                                      v-bind:key="index"
                                    >{{employmenttype.indexDetailName}}</option>
                                  </select>

                                  <span class="bar"></span>
                                  <label class="label-create required negmargin10">Employment Type</label>

                                </div>
                                <div v-if="errors.has('exp.expemploymentType')" class="alert-danger">{{ errors.first('exp.expemploymentType') }}</div>
                              </div>
                              <div class="col-lg-6 col-md-6 col-sm-12 exppadding  pt-2 pt-md-0">
                                <div class="input-group">
                                <small class="required small-label">Select Country</small>
                                <multiselect
                                  v-model="selectedMultiselectExpCountry"
                                  v-validate=" 'required' "
                                  :name="'expcountry'"
                                  class="multiselect multiselectInput-create proximanova"
                                  :options="countryList"
                                  label="countryName"
                                  :multiple="false"
                                  :close-on-select="true"
                                  :clear-on-select="true"
                                  :hide-selected="true"
                                  :preserve-search="true"
                                  track-by="countryName"
                                  @select="onSelectExpConytry"
                                  placeholder="Select Country"
                                  :show-labels="false"
                                  data-vv-as="Select Country"
                                  data-vv-scope="exp"
                                  required>
                              </multiselect>
                                <span class="bar"></span>
                                <!-- <label class="label-create required">Select Country</label> -->

                              </div>
                              <div v-if="errors.has('exp.expcountry') && !selectedMultiselectExpCountry" class="alert-danger">{{ errors.first('exp.expcountry') }}</div>
                              </div>
                            </div>
                            <!-- <div class="col d-flex ml-lg-2 ml-md-2">

                                    <div
                                      v-if="errors.has('expemploymentType')"
                                      class="alert-danger col-6"
                                    >{{ errors.first('expemploymentType') }}</div>
                                    <div
                                      v-else
                                      class="alert-danger col-6"
                                    ></div>

                                    <div
                                      v-if="errors.has('expcountry')"
                                      class="alert-danger col-6"
                                    >{{ errors.first('expcountry') }}</div>

                            </div> -->
                          </div>
                          <div class="row no-gutters">
                          <div class="col d-md-flex justify-content-start align-items-center ml-lg-2 ml-md-2">
                            <div class="col-lg-6 col-md-6 col-sm-12 exppadding">
                              <div class="input-group mb-3">
                                <small class="required small-label">State</small>
                                <multiselect
                                  v-model="selectedMultiselectExpState"
                                  v-validate=" 'required' "
                                  :name="'expState'"
                                  class="multiselect multiselectInput-create proximanova"
                                  :options="workStateslist"
                                  label="stateName"
                                  :multiple="false"
                                  :close-on-select="true"
                                  :clear-on-select="true"
                                  :hide-selected="true"
                                  :preserve-search="true"
                                  track-by="stateName"
                                  @select="onSelectExpState"
                                  placeholder="Select State"
                                  :show-labels="false"
                                  data-vv-as="State"
                                  data-vv-scope="exp"
                                  required>
                              </multiselect>
                                <span class="bar"></span>
                                <!-- <label class="label-create required">State</label> -->
                              </div>
                              <div v-if="errors.has('exp.expState') && !selectedMultiselectExpState" class="alert-danger">{{ errors.first('exp.expState') }}</div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12 exppadding">
                              <div class="input-group mb-3">
                                <small class="required small-label">City</small>
                                <multiselect
                                  v-model="selectedMultiselectExpCity"
                                  v-validate=" 'required' "
                                  :name="'expCity'"
                                  class="multiselect multiselectInput-create"
                                  :options="workCitiesList"
                                  label="cityName"
                                  :multiple="false"
                                  :close-on-select="true"
                                  :clear-on-select="true"
                                  :hide-selected="true"
                                  :preserve-search="true"
                                  track-by="cityName"
                                  @select="onSelectExpCity"
                                  placeholder="Select city"
                                  :show-labels="false"
                                  data-vv-as="City"
                                  data-vv-scope="exp"
                                  required>
                                </multiselect>
                                <span class="bar"></span>
                              </div>
                              <div v-if="errors.has('exp.expCity') && !selectedMultiselectExpCity" class="alert-danger">{{ errors.first('exp.expCity') }}</div>
                              <!-- <div class="input-group">
                                  <input 
                                    type="text"
                                    data-vv-as="City"
                                    data-vv-scope="exp"
                                    :name="'expCityexpCity'"
                                    class="input-create"
                                    @keyup="checkexperiencecity()"
                                    autocomplete="off"
                                    v-model="selectedMultiselectExpCity"
                                    v-validate=" 'required' "
                                    required
                                  />
                                  <span class="bar"></span>
                                  <label class="label-create required">City</label>
                                  <div class="dropdown-menu col-10 d-flex" id="LocationDropdown" v-if="workCitiesList.length > 0"> 
                                    <div class="fontsize12 col-12 pl-0 pr-0 black60 proximanova pointer">
                                      <li class="list-group-item pl-3" :value="city.id" v-for="(city,i) in workCitiesList" :key="i" @click="onSelectExpCity(city.cityName,i,city.cityId)">
                                        {{city.cityName}}
                                      </li>
                                    </div>
                                  </div>
                                </div> -->
                            </div>
                          </div>
                           <!-- <div class="col d-flex ml-lg-2 ml-md-2">

                                  <div
                                    v-if="errors.has('expState')"
                                    class="alert-danger col-6"
                                  >{{ errors.first('expState') }}</div>
                                <div
                                      v-else
                                      class="alert-danger col-6"
                                    ></div>

                                  <div
                                    v-if="errors.has('expCity')"
                                    class="alert-danger col-6"
                                  >{{ errors.first('expCity') }}</div>

                             </div> -->
                        </div>
                          <div class="row no-gutters mb-3">
                            <div class="col d-md-flex justify-content-start align-items-center ml-lg-2 ml-md-2">
                              <div class="col-lg-6 col-md-6 col-sm-12 exppadding">
                                <div class="input-group">
                                  <small class="required small-label">Start Date (YYYY-MM)</small>
                                  <!-- <input
                                    type="date"
                                    :name="'expstartDate'"
                                    v-validate=" 'required' "
                                    data-vv-as="Start Date"
                                    data-vv-scope="exp"
                                    @change="checkStartDate"
                                    class="input-create dob"
                                    id="startDate"
                                    v-model="exp.startDate"
                                    required
                                  /> -->
                                  <date-picker 
                                  :name="'expstartDate'"
                                  v-validate=" 'required' "
                                  data-vv-as="Start Date"
                                  data-vv-scope="exp"
                                  type="month"
                                  v-model="exp.startDate" 
                                  class="input-create dob" 
                                  id="startDate"
                                  @change="checkStartDate"
                                  format = "YYYY-MM" 
                                  valueType="format"
                                  required
                                  ></date-picker>
                                  <span class="bar input-group-addon"></span>
                                </div>
                                <div v-if="errors.has('exp.expstartDate') && !exp.startDate" class="alert-danger">{{ errors.first('exp.expstartDate') }}</div>
                                <div class="alert-danger ml-1">{{checkStartDateMessage}}</div>
                              </div>
                              <div class="col-lg-6 col-md-6 col-sm-12 pt-2 pt-md-0 exppadding" v-if="exp.workStatus=== 'Y'" >
                                <div class="input-group">
                                  <input
                                    type="text"
                                    class="input-create"
                                    disabled
                                    id="endDate"
                                  />
                                  <span class="bar input-group-addon"></span>
                                  <label class="label-create required">End Date</label>
                                </div>
                              </div>
                              <div class="col-lg-6 col-md-6 col-sm-12 exppadding pt-2 pt-md-0" v-else >
                                <div class="input-group">
                                  <small class="required small-label">End Date (YYYY-MM)</small>
                                  <!-- <input
                                    type="date"
                                    :name="'expendDate'"
                                    v-validate=" 'required' "
                                    data-vv-as="End Date"
                                    data-vv-scope="exp"
                                    @change="checkDate"
                                    class="input-create dob"
                                    id="endDate"
                                    v-model="exp.endDate"
                                    required
                                  /> -->
                                  <date-picker 
                                  :name="'expendDate'"
                                  v-validate=" 'required' "
                                  data-vv-as="End Date"
                                  data-vv-scope="exp"
                                  format = "YYYY-MM"
                                  type="month"
                                  v-model="exp.endDate" 
                                  class="input-create dob" 
                                  id="endDate"
                                  @change="checkDate" 
                                  valueType="format"
                                  required
                                  ></date-picker>
                                  <span class="bar input-group-addon"></span>
                                </div>
                                <div v-if="errors.has('exp.expendDate') && !exp.endDate" class="alert-danger ml-1">{{ errors.first('exp.expendDate') }}</div>
                                <div class="alert-danger ml-1">{{checkDateMessage}}</div>
                              </div>
                            </div>
                            <!-- <div class="col d-flex ml-lg-2 ml-md-2">

                                    <div
                                      v-if="errors.has('expstartDate')"
                                      class="alert-danger col-6 "
                                    >{{ errors.first('expstartDate') }}</div>
                                   <div class="alert-danger col-6 ml-1">{{checkStartDateMessage}}</div>

                                    <div
                                      v-if="errors.has('expendDate') && (exp.workStatus=='Y')"
                                      class="alert-danger col-6 ml-1"
                                    >{{ errors.first('expendDate') }}</div>
                                    <div class="alert-danger col-6 ml-1">{{checkDateMessage}}</div>

                            </div> -->
                          </div>
                          <div class="row no-gutters mb-3 ml-3">
                          <div class="col d-flex justify-content-start align-items-center">
                             <!-- <div class="col-6">
                             </div> -->
                              <div class="col">
                            <input type="checkbox" @click="clearEndDate()" id="expworkstatus" true-value="Y" false-value="N" v-model="exp.workStatus"> <span class="ml-2 proximanova">Currently Working here</span>
                              </div>
                          </div>
                        </div>
                          <div class="row no-gutters">
                            <div class="col d-flex justify-content-start align-items-center ml-lg-2 ml-md-2">
                              <div class="form-group ml-2">
                                <label for="exampleFormControlTextarea2" class="proximanova">
                                  Description
                                  <span>(Optional)</span><div class="d-flex">(<p id="charactersRemaining2">600</p><p>/600 )</p></div>
                                </label>
                                <textarea
                                  class="form-control proximanova"
                                  id="exampleFormControlTextarea2"
                                  v-model="exp.description"
                                  spellcheck="true"
                                  @keyup="experiencedescription()"
                                  rows="5"
                                  cols="77"
                                  maxlength="600"
                                ></textarea>
                              </div>
                            </div>
                          </div>



                        </div>
                      <div class="float-right p-2">
                        <button class="mr-3 btn button-cancel1" v-if="hidedisplayexperienceInput"  @click="clearExpObject">
                          <span class="proximanova">Cancel</span>
                        </button>
                        <button class="mr-3 btn backgroundcolorblack sign-up-button" v-if="hidedisplayexperienceInput" id="updateWorkexpButton"  @click="updateExpObject">
                          <span class="button-create-font proximanova" v-if="editExpObject">Save</span>
                          <span class="button-create-font proximanova" v-else>Create</span>
                        </button>
                      </div>
                      <div v-if="!hidedisplayexperienceInput" class="addmore" @click="addExperience" >
                        <img src="../assets/AddMore.svg" class="ml-3 proximanova"  alt="add" />Add More Experiences
                      </div>
                    </div>
                  </div>
                  <div
                    class="card-footer collapse"
                    id="faq3"
                    aria-labelledby="faqhead3"
                    data-parent="#faq"
                  >
                  </div>
                </div>
                        </div>
            </div>
            <div class="row no-gutters ml-3 mr-3 ml-md-4 mr-lg-1 mb-3">
                        <div class="col-12">
                          <!-- work experience section -->
                          <!-- user can able to add multiple educations -->
                <div class="card">
                  <div class="card-header" id="faqhead4">
                    <div v-if="this.profileID!=null">
                    <a
                      class="btn btn-header-link collapsed proximanova-semibold"
                      data-toggle="collapse"
                      data-target="#faq4"
                      aria-expanded="true"
                      aria-controls="faq4"
                      @click="toggleActiveClass('education')"
                    >Education/Certifications</a>
                    </div>
                    <div v-else>
                    <a
                      class="btn btn-header-link collapsed proximanova-semibold"
                      data-toggle="collapse show"
                      data-target="#faq1"
                      aria-expanded="true"
                      aria-controls="faq1"
                    >Education/Certifications</a>
                    </div>
                  </div>

                  <div id="faq4" class="collapse" aria-labelledby="faqhead4" data-parent="#faq">
                    <div class="education" v-for="(certiobj , index) in certificates" :key="index">
                        <div class="educat pt-3 pb-3 border">
                          <div class="col-12 pl-0">
                            <div class="d-flex justify-content-between">
                                <div class="col-9 col-md-8">
                                  <div class="d-flex ml-1">
                                    <img src="../assets/Company_Icon.svg" alt="companyicon" class="img-fluid rounded-circle">
                                    <div class="ml-1 flex-nowrap proximanova-bold fontsize14 black text-capitalize"> {{certiobj.institution}}</div>
                                  </div>
                                  <div class="flex-nowrap pl-4 ml-2 proximanova fontsize14 black80 text-capitalize">
                                    <div>{{certiobj.fieldOfStudy}}</div>
                                  </div>
                                </div>
                                <div class="d-flex mr-lg-2 mr-sm-1 justify-content-between">
                                  <div class="d-flex mr-lg-2 mr-sm-1 pointer" @click="editCertification(index)">
                                    <img src="../assets/Edit.svg" alt="edit" style="width:26px">
                                    <div class="ml-1 d-none d-lg-block my-auto fontsize14 proximanova">Edit</div>
                                  </div>
                                  <div class="d-flex ml-2 pointer" @click="deleteCertificationModal(index)" data-toggle="modal" data-target="#deleteEduModal">
                                    <img src="../assets/Deleteall.svg" alt="delete" style="width:28px">
                                    <div class="ml-1 d-none d-lg-block my-auto fontsize14 proximanova">Delete</div>
                                  </div>
                                  <div class="modal fade" id="deleteEduModal" tabindex="-1" role="dialog" aria-labelledby="deleteEduModalLabel" aria-hidden="true">
                                      <div class="modal-dialog " role="document">
                                        <div class="modal-content">
                                          <div class="modal-header delete-modal pb-0">
                                            <h5 class="modal-title fontsize20 black80 proximanova" id="deleteEduModalLabel">Are you sure you want to delete this record ?</h5>
                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="clearSelectedCertificationsIndex">
                                              <span aria-hidden="true">&times;</span>
                                            </button>
                                          </div>
                                          <div class="modal-body modal-delete text-center mt-2">
                                            <span class="button-cancel-font modaldeletebtn border rounded p-2 pr-4 pl-4 proximanova" data-dismiss="modal" aria-label="Close" @click="clearSelectedCertificationsIndex">No</span>
                                            <span class="button-cancel-font backgroundcolorblack border p-2 ml-2 pr-4 pl-4 rounded proximanova" @click="deleteCertification" >Yes</span>
                                          </div>
                                        </div>
                                      </div>
                                  </div>
                                </div>
                            </div>
                          </div>
                        </div>
                    </div>
                    <div class="card-body">
                      <div v-if="duplicatestudyFlag" class="text-center"><span class="duplicateError proximanova">Duplicate records existed. plese check your Data.</span></div>
                      <div class="alert-danger  ml-1 text-center">{{AddCertificatesErrorMessage}}</div>
                      <div >
                        <div class="form" v-if="hidedisplayeducationInput">
                          <div class="row no-gutters mb-3">
                            <div class="col d-md-flex justify-content-start align-items-center ml-lg-2 ml-md-2">
                              <div class="col-lg-6 col-md-6 col-sm-12 edupadding">
                                <div class="input-group">
                                  <input
                                    type="text"
                                    :name="'certificatesobjinstitution'"
                                    data-vv-as="Institution Name"
                                    data-vv-scope="edu"
                                    class="input-create"
                                    id="education"
                                    @keyup="checkeducationinstitute()"
                                    autocomplete="off"
                                    v-model="certificatesobj.institution"
                                    v-validate=" 'required' "
                                    required
                                  />

                                  <span class="bar"></span>
                                  <label class="label-create required">Institution Name</label>
                                  <!-- <ul id="instname" class="searchResults text-center w-100">
                                    <li class="border"
                                      v-for="(institution,filterindex) in institutionnameList"
                                      :value="institution.id"
                                      :key="filterindex"
                                      @click="addinstitute(institution.instituteName,filterindex,institution.id)"
                                    >{{institution.instituteName}}</li>
                                  </ul> -->
                                  <div class="dropdown-menu col-10 d-flex" id="LocationDropdown" v-if="institutionnameList.length > 0"> 
                                    <div class="fontsize12 col-12 pl-0 pr-0 black60 proximanova pointer">
                                      <li class="list-group-item pl-3" :value="institution.id" v-for="(institution,filterindex) in institutionnameList" :key="filterindex" @click="addinstitute(institution.instituteName,filterindex,institution.id)">
                                        {{institution.instituteName}}
                                      </li>
                                    </div>
                                  </div>
                                </div>
                                <div v-if="errors.has('edu.certificatesobjinstitution')" class="alert-danger">{{ errors.first('edu.certificatesobjinstitution') }}</div>
                                <div v-if="!valideducollegename" class="alert-danger">College Name shouldn't start with special characters</div>
                              </div>
                              <div class="col-lg-6 col-md-6 col-sm-12 pt-4 pt-md-0 edupadding">
                                <div class="input-group mt-lg-2">
                                  <select
                                    type="text"
                                    v-validate=" 'required' "
                                    :name="'certificatesobjtypeOfDegreeId'"
                                    data-vv-as="Type of Degree"
                                    data-vv-scope ="edu"
                                    class="input-create"
                                    onclick="this.setAttribute('value', this.value);"
                                    v-model="certificatesobj.typeOfDegreeId"
                                    required
                                  >
                                    <option
                                      v-for="(degree,index) in typeOfDegreeList"
                                      v-bind:value="degree.id"
                                      v-bind:key="index"
                                    >{{degree.indexDetailName}}</option>
                                  </select>
                                  <span class="bar"></span>
                                  <label class="label-create required negmargin10">Type of Degree</label>

                                </div>
                                <div v-if="errors.has('edu.certificatesobjtypeOfDegreeId')" class="alert-danger ml-2">{{ errors.first('edu.certificatesobjtypeOfDegreeId') }}</div>
                              </div>
                            </div>
                            <!-- <div class="col d-flex ml-lg-2 ml-md-2">

                                    <div
                                      v-if="errors.has('certificatesobjinstitution')"
                                      class="alert-danger col-6"
                                    >{{ errors.first('certificatesobjinstitution') }}</div>
                                     <div
                                    v-else
                                    class="alert-danger col-6"
                                  ></div>
                                    <div
                                      v-if="errors.has('certificatesobjtypeOfDegreeId')"
                                      class="alert-danger col-6 ml-2"
                                    >{{ errors.first('certificatesobjtypeOfDegreeId') }}</div>

                            </div> -->
                          </div>
                          <div class="row no-gutters  mb-3">
                            <div class="col d-md-flex justify-content-start align-items-center ml-lg-2 ml-md-2">
                              <div class="col-lg-6 col-md-6 col-sm-12 edupadding">
                                <div class="input-group mt-lg-2">
                                  <input
                                    type="text"
                                    v-validate=" 'required' "
                                    :name="'certificatesobjfieldOfStudy'"
                                    data-vv-as="Field of Study"
                                    data-vv-scope ="edu"
                                    class="input-create"
                                    autocomplete="off"
                                    @keyup="checkeducationField()"
                                    v-model="certificatesobj.fieldOfStudy"
                                    required
                                  />

                                  <span class="bar"></span>
                                  <label class="label-create required">Field of Study</label>
                                  <!-- <ul id="fieldname" class="searchResults text-center w-100">
                                    <li class="border"
                                      v-for="(field,index) in fieldList"
                                      :value="field.id"
                                      :key="index"
                                      @click="addfieldOfStudy(field.fieldName,index,field.id)"
                                    >{{field.fieldName}}</li>
                                  </ul> -->
                                  <div class="dropdown-menu col-10 d-flex" id="LocationDropdown" v-if="fieldList.length > 0"> 
                                    <div class="fontsize12 col-12 pl-0 pr-0 black60 proximanova pointer">
                                      <li class="list-group-item pl-3" :value="field.id" v-for="(field,index) in fieldList" :key="index" @click="addfieldOfStudy(field.fieldName,index,field.id)">
                                        {{field.fieldName}}
                                      </li>
                                    </div>
                                  </div>
                                </div>
                                <div v-if="errors.has('edu.certificatesobjfieldOfStudy')" class="alert-danger">{{ errors.first('edu.certificatesobjfieldOfStudy') }}</div>  
                                <div v-if="!validedufieldofstudy" class="alert-danger">Field of study shouldn't start with special characters</div>
                              </div>
                              <div class="col-lg-6 col-md-6 col-sm-12 pt-2 pt-md-0 edupadding">
                                <div class="input-group">
                                <small class="required small-label">Select Country</small>
                                <multiselect
                                  v-model="selectedMultiselectEduCountry"
                                  v-validate=" 'required' "
                                  :name="'certificatesobjcountry'"
                                  class="multiselect multiselectInput-create proximanova"
                                  :options="countryList"
                                  label="countryName"
                                  :multiple="false"
                                  :close-on-select="true"
                                  :clear-on-select="true"
                                  :hide-selected="true"
                                  :preserve-search="true"
                                  track-by="countryId"
                                  @select="onSelectEduCountry"
                                  placeholder="Select Country"
                                  :show-labels="false"
                                  data-vv-as="Select Country"
                                  data-vv-scope ="edu"
                                  required>
                                </multiselect>
                                <span class="bar"></span>

                              </div>
                              <div v-if="errors.has('edu.certificatesobjcountry') && !selectedMultiselectEduCountry" class="alert-danger">{{ errors.first('edu.certificatesobjcountry') }}</div>
                              </div>
                            </div>
                            <!-- <div class="col d-flex ml-lg-2 ml-md-2">

                                    <div
                                      v-if="errors.has('certificatesobjfieldOfStudy')"
                                      class="alert-danger col-6"
                                    >{{ errors.first('certificatesobjfieldOfStudy') }}</div>
                                    <div
                                      v-else
                                      class="alert-danger col-6"
                                    ></div>

                                    <div
                                      v-if="errors.has('certificatesobjcountry')"
                                      class="alert-danger col-6"
                                    >{{ errors.first('certificatesobjcountry') }}</div>

                            </div> -->
                          </div>
                          <div class="row no-gutters mb-3">
                          <div class="col d-md-flex justify-content-start align-items-center ml-lg-2 ml-md-2">
                            <div class="col-lg-6 col-md-6 col-sm-12 edupadding">
                              <div class="input-group">
                                <small class="required small-label">State</small>
                                <multiselect
                                  v-model="selectedMultiselectEduState"
                                  v-validate=" 'required' "
                                  :name="'certificatesobjState'"
                                  class="multiselect multiselectInput-create proximanova"
                                  :options="educationStateslist"
                                  label="stateName"
                                  :multiple="false"
                                  :close-on-select="true"
                                  :clear-on-select="true"
                                  :hide-selected="true"
                                  :preserve-search="true"
                                  track-by="stateId"
                                  @select="onSelectEduState"
                                  placeholder="Select State"
                                  :show-labels="false"
                                  data-vv-as="State"
                                  data-vv-scope ="edu"
                                  required>
                                </multiselect>
                                <span class="bar"></span>
                              </div>
                              <div v-if="errors.has('edu.certificatesobjState') && !selectedMultiselectEduState" class="alert-danger">{{ errors.first('edu.certificatesobjState') }}</div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12 pt-1 pt-md-0 edupadding">
                              <div class="input-group">
                                <small class="required small-label">City</small>
                                <multiselect
                                  v-model="selectedMultiselectEduCity"
                                  v-validate=" 'required' "
                                  :name="'certificatesobjCity'"
                                  class="multiselect multiselectInput-create"
                                  :options="educationCitiesList"
                                  label="cityName"
                                  :multiple="false"
                                  :close-on-select="true"
                                  :clear-on-select="true"
                                  :hide-selected="true"
                                  :preserve-search="true"
                                  track-by="cityId"
                                  @select="onSelectEduCity"
                                  placeholder="Select City"
                                  :show-labels="false"
                                  data-vv-as="City"
                                  data-vv-scope ="edu"
                                  required>
                                </multiselect>
                                <span class="bar"></span>

                              </div>
                              <div v-if="errors.has('edu.certificatesobjCity') && !selectedMultiselectEduCity" class="alert-danger">{{ errors.first('edu.certificatesobjCity') }}</div>
                              <!-- <div class="input-group mt-lg-2">
                                  <input 
                                    type="text"
                                    data-vv-as="City"
                                    data-vv-scope="edu"
                                    :name="'city'"
                                    class="input-create"
                                    @keyup="checkeducationcity()"
                                    autocomplete="off"
                                    v-model="selectedMultiselectEduCity"
                                    v-validate=" 'required' "
                                    required
                                  />
                                  <span class="bar"></span>
                                  <label class="label-create required">City</label>
                                  <div class="dropdown-menu col-10 d-flex" id="LocationDropdown" v-if="educationCitiesList.length > 0"> 
                                    <div class="fontsize12 col-12 pl-0 pr-0 black60 proximanova pointer">
                                      <li class="list-group-item pl-3" v-for="(city,i) in educationCitiesList" :value="city.id" :key="i" @click="onSelectEduCity(city.cityName,i,city.cityId)">
                                        {{city.cityName}}
                                      </li>
                                    </div>
                                  </div>
                                </div> -->
                            </div>
                          </div>
                           <!-- <div class="col d-flex ml-lg-2 ml-md-2">

                                  <div
                                    v-if="errors.has('certificatesobjState')"
                                    class="alert-danger col-6"
                                  >{{ errors.first('certificatesobjState') }}</div>
                                <div
                                      v-else
                                      class="alert-danger col-6"
                                    ></div>

                                  <div
                                    v-if="errors.has('certificatesobjCity')"
                                    class="alert-danger col-6"
                                  >{{ errors.first('certificatesobjCity') }}</div>

                             </div> -->
                        </div>

                          <div class="row no-gutters mb-3">
                            <div class="col d-md-flex justify-content-start align-items-center  ml-lg-2 ml-md-2">
                              <div class="col-lg-6 col-md-6 col-sm-12 edupadding">
                                <div class="input-group">
                                  <small class="required small-label">Start Date (YYYY-MM)</small>
                                  <!-- <input
                                    type="date"
                                    :name="'certificatesobjstartDate'"
                                    v-validate=" 'required' "
                                    data-vv-scope ="edu"
                                    data-vv-as="Start Date"
                                    class="input-create dob"
                                    @change="checkEducationStartDate()"
                                    id="eduStartDate"
                                    v-model="certificatesobj.startDate"
                                    required
                                  /> -->
                                  <date-picker 
                                  :name="'certificatesobjstartDate'"
                                  v-validate=" 'required' "
                                  data-vv-scope ="edu"
                                  data-vv-as="Start Date"
                                  type="month"
                                  v-model="certificatesobj.startDate" 
                                  class="input-create dob" 
                                  id="eduStartDate"
                                  @change="checkEducationStartDate()" 
                                  valueType="format"
                                  required
                                  ></date-picker>
                                  <span class="bar"></span>

                                </div>
                                <div v-if="errors.has('edu.certificatesobjstartDate') && !certificatesobj.startDate" class="alert-danger ml-2">{{ errors.first('edu.certificatesobjstartDate') }}</div>      
                                <div v-else class="alert-danger" >{{checkEducationStartDateMessage}}</div>
                              </div>
                              <div class="col-lg-6 col-md-6 col-sm-12 pt-2 pt-md-0 edupadding" v-if="certificatesobj.studyStatus == 'Y'">
                                <div class="input-group">
                                  <input
                                    type="text"
                                    id="eduEndDate"
                                    class="input-create"
                                    disabled
                                  />
                                  <span class="bar"></span>
                                  <label class="label-create required">End Date</label>

                                </div>
                              </div>
                              <div class="col-lg-6 col-md-6 col-sm-12 pt-2 pt-md-0 edupadding" v-else>
                                <div class="input-group">
                                  <small class="required small-label">End Date (YYYY-MM)</small>
                                  <!-- <input
                                    type="date"
                                    :name="'certificatesobjendDate'"
                                    id="eduEndDate"
                                    v-validate=" 'required' "
                                    data-vv-as="End Date"
                                    class="input-create dob"
                                    data-vv-scope ="edu"
                                    @change="checkEducationEndDate()"
                                    v-model="certificatesobj.endDate"
                                    required
                                  /> -->
                                  <date-picker 
                                  :name="'certificatesobjendDate'"
                                  v-validate=" 'required' "
                                  data-vv-scope ="edu"
                                  data-vv-as="End Date"
                                  type="month"
                                  v-model="certificatesobj.endDate" 
                                  class="input-create dob" 
                                  id="eduEndDate"
                                  @change="checkEducationEndDate()" 
                                  valueType="format"
                                  required
                                  ></date-picker>
                                  <span class="bar"></span>

                                </div>
                                <div v-if="errors.has('edu.certificatesobjendDate') && !certificatesobj.endDate" class="alert-danger ml-2">{{ errors.first('edu.certificatesobjendDate') }}</div>
                                <div v-else class="alert-danger">{{checkEducationEndDateMessage}}</div>
                              </div>
                            </div>
                          </div>
                          <!-- <div class="col d-flex ml-lg-2 ml-md-2"> 
                            <div v-if="errors.has('certificatesobjstartDate')" class="alert-danger col-6 ml-2">{{ errors.first('certificatesstartDate') }}</div>
                            <div v-else class="alert-danger col-6">{{checkEducationStartDateMessage}}</div>
                            <div v-if="errors.has('certificatesobjendDate')" class="alert-danger col-6 ml-2">{{ errors.first('certificatesobjendDate') }}</div>
                            <div v-else class="alert-danger col-6">{{checkEducationEndDateMessage}}</div>
                          </div> -->
                          <div class="row no-gutters mb-3 ml-3">
                          <div class="col d-flex justify-content-start align-items-center ml-lg-2 ml-md-2">
                            <div>
                            <input type="checkbox" value="Y" v-model="certificatesobj.studyStatus" @click="clearStudyEndDate()" true-value="Y" false-value="N"> <span class="ml-2 proximanova">Currently Studying here</span>
                          </div>
                          </div>
                        </div>
                        </div>
                      </div>
                      <div class="float-right">
                        <button class="mr-3 btn button-cancel1" v-if="hidedisplayeducationInput" @click="clearcertificationsObject">
                          <span class="proximanova">Cancel</span>
                        </button>
                        <button class="mr-3 btn backgroundcolorblack sign-up-button" v-if="hidedisplayeducationInput" id="updatecertificatesButton" @click="updatecertificationsObject">
                          <span class="button-create-font proximanova" v-if="editCertificatesObject">Save</span>
                          <span class="button-create-font proximanova" v-else>Create</span>
                        </button>
                      </div>
                      <div v-if="!hidedisplayeducationInput" class="addmore" v-on:click="addCertification()">
                        <img src="../assets/AddMore.svg" class="ml-3"  alt="add"/>
                        <span class="ml-2 proximanova">Add More Certification</span>
                      </div>
                    </div>
                  </div>
                  <div
                    class="card-footer collapse"
                    id="faq4"
                    aria-labelledby="faqhead4"
                    data-parent="#faq"
                  >

                  </div>
                </div>
                        </div>
            </div>
            <div class="row no-gutters ml-3 mr-3 ml-md-4 mr-lg-1 mb-3">
                        <div class="col-12">
                          <!-- current location -->
                <div class="card">
                  <div class="card-header" id="faqhead5">
                     <div v-if="this.profileID!=null">
                    <a
                      class="btn btn-header-link collapsed proximanova-semibold"
                      data-toggle="collapse"
                      data-target="#faq5"
                      aria-expanded="true"
                      aria-controls="faq5"
                      @click="toggleActiveClass('current_location')"
                    >Current Location</a>
                     </div>
                     <div v-else>
                    <a
                      class="btn btn-header-link collapsed proximanova-semibold"
                      data-toggle="collapse show"
                      data-target="#faq1"
                      aria-expanded="true"
                      aria-controls="faq1"
                    >Current Location</a>
                    </div>
                  </div>

                  <div id="faq5" class="collapse" aria-labelledby="faqhead5" data-parent="#faq">
                    <div class="card-body">
                      <div class="form">
                        <div class="row no-gutters">
                          <div class="col d-md-flex justify-content-start align-items-center ml-lg-2 ml-md-2">
                            <div class="col-lg-6 col-md-6 col-sm-12 locInput">
                              <div class="input-group mb-3">
                                <small class="required small-label">Select Country</small>

                                <multiselect
                                  v-model="selectedMultiselectLocCountry"
                                  v-validate=" 'required' "
                                  name="Select Country"
                                  class="multiselect multiselectInput-create proximanova"
                                  :options="countryList"
                                  label="countryName"
                                  :multiple="false"
                                  :close-on-select="true"
                                  :clear-on-select="true"
                                  :hide-selected="true"
                                  :preserve-search="true"
                                  track-by="countryId"
                                  @select="onSelectLocCountry"
                                  placeholder="Select Country"
                                  :show-labels="false"
                                  data-vv-as="Select Country"
                                  data-vv-scope="location"
                                  required>
                                </multiselect>
                                <span class="bar"></span>
                                <center>
                                  <div
                                    v-if="errors.has('location.Select Country') && !selectedMultiselectLocCountry"
                                    class="alert-danger"
                                  >{{ errors.first('location.Select Country') }}</div>
                                </center>
                              </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12 pt-2 pt-md-0 locInput">
                              <div v-if="this.country == 233">
                                <div class="input-group mt-3">
                                  <select
                                    type="text"
                                    v-validate=" 'required' "
                                    name="Work Authorization"
                                    data-vv-as="Work Authorization"
                                    class="input-create proximanova"
                                    data-vv-scope="location"
                                    v-model="workAuthorization"
                                    required
                                  >
                                    <option
                                      v-for="(work,index) in workAuthorizationList"
                                      :value="work.id"
                                      :key="index"
                                    >{{work.indexDetailName}}</option>
                                  </select>
                                  <span class="bar"></span>
                                  <label class="label-create required">Work Authorization</label>
                                  <center>
                                    <div
                                      v-if="errors.has('location.Work Authorization')"
                                      class="alert-danger"
                                    >{{ errors.first('location.Work Authorization') }}</div>
                                  </center>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row no-gutters">
                          <div class="col d-md-flex justify-content-start align-items-center ml-lg-2 ml-md-2">
                            <div class="col-lg-6 col-md-6 col-sm-12 locInput">
                              <div class="input-group mb-3">
                                <small class="required small-label">State</small>

                                <multiselect
                                  v-model="selectedMultiselectLocState"
                                  v-validate=" 'required' "
                                  name="State"
                                  class="multiselect multiselectInput-create proximanova"
                                  :options="stateslist"
                                  label="stateName"
                                  :multiple="false"
                                  :close-on-select="true"
                                  :clear-on-select="true"
                                  :hide-selected="true"
                                  :preserve-search="true"
                                  track-by="stateId"
                                  @select="onSelectLocState"
                                  placeholder="Select State"
                                  :show-labels="false"
                                  data-vv-scope="location"
                                  data-vv-as="State"
                                  required>
                                </multiselect>
                                <span class="bar"></span>
                                <center>
                                  <div
                                    v-if="errors.has('location.State') && !selectedMultiselectLocState"
                                    class="alert-danger"
                                  >{{ errors.first('location.State') }}</div>
                                </center>
                              </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12 locInput">
                              <div class="input-group mb-3">
                                <small class="required small-label">City</small>

                                <multiselect
                                  v-model="selectedMultiselectLocCity"
                                  v-validate=" 'required' "
                                  name="City"
                                  class="multiselect multiselectInput-create"
                                  :options="citiesList"
                                  label="cityName"
                                  :multiple="false"
                                  :close-on-select="true"
                                  :clear-on-select="true"
                                  :hide-selected="true"
                                  :preserve-search="true"
                                  track-by="cityId"
                                  @select="onSelectLocCity"
                                  placeholder="Select City"
                                  :show-labels="false"
                                  data-vv-as="City"
                                  data-vv-scope="location"
                                  required>
                                </multiselect>
                                <span class="bar"></span>
                                <center>
                                  <div
                                    v-if="errors.has('location.City') && !selectedMultiselectLocCity"
                                    class="alert-danger"
                                  >{{ errors.first('location.City') }}</div>
                                </center>
                              </div>
                              <!-- <div class="input-group">
                                <input 
                                  type="text"
                                  data-vv-as="City"
                                  data-vv-scope="location"
                                  :name="'city'"
                                  class="input-create"
                                  @keyup="checklocationcity()"
                                  autocomplete="off"
                                  v-model="selectedMultiselectLocCity"
                                  v-validate=" 'required' "
                                  required
                                />
                                <span class="bar"></span>
                                <label class="label-create required">City</label>
                                <div class="dropdown-menu col-10 d-flex" id="LocationDropdown" v-if="citiesList.length > 0"> 
                                    <div class="fontsize12 col-12 pl-0 pr-0 black60 proximanova pointer">
                                      <li class="list-group-item pl-3" v-for="(city,i) in citiesList" :key="i" :value="city.id" @click="onSelectLocCity(city.cityName,i,city.cityId)">
                                        {{city.cityName}}
                                      </li>
                                    </div>
                                  </div>
                                <center>
                                  <div
                                    v-if="errors.has('location.City') && !selectedMultiselectLocCity"
                                    class="alert-danger"
                                  >{{ errors.first('location.City') }}</div>
                                </center>
                              </div> -->
                            </div>
                          </div>
                        </div>
                        <div class="row no-gutters">
                          <!-- <div class="col d-flex justify-content-start align-items-center ml-lg-2 ml-md-2"  v-if="this.country == 1">
                            <div class="col-6 locInput">

                              <div class="input-group mb-3">
                                 <input
                                  type="text"
                                  name="Pin Code"
                                  data-vv-scope="location"
                                  v-validate="{ required:true, regex:/^[1-9]{1}[0-9]{2}\s{0,1}[0-9]{3}$/, digits:6 }"
                                  data-vv-as="Pin Code"
                                  class="input-create"
                                  autocomplete="off"
                                  @keyup="checkLocation"
                                  v-model="pinCode"
                                   maxlength="6"
                                  required
                                />

                                <span class="bar"></span>

                                  <label class="label-create required">Pin Code</label>

                                <center>
                                  <div
                                    v-if="errors.has('location.Pin Code')"
                                    class="alert-danger"
                                  >{{ errors.first('location.Pin Code') }}</div>
                                </center>
                              </div>
                            </div>
                          </div>
                          <div class="row no-gutters"  v-if="this.country == 2">
                             <div class="col-6 locInput ml-lg-2 ml-md-2 ">
                              <div class="input-group mb-3">
                                <input
                                  type="text"
                                  name="Zip Code"
                                  v-validate="{  required:true, regex: /^(\d)(?!\1+$)/, digits:5 }"
                                  data-vv-as="Zip Code"
                                  class="input-create"
                                  data-vv-scope="location"
                                  autocomplete="off"
                                  @keyup="checkLocation"
                                  v-model="pinCode"
                                   maxlength="5"
                                  required
                                />
                                <span class="bar"></span>


                                  <label class="label-create required">Zip Code</label>

                                <center>
                                  <div
                                    v-if="errors.has('location.Zip Code')"
                                    class="alert-danger"
                                  >{{ errors.first('location.Zip Code') }}</div>
                                </center>
                              </div>
                              </div>



                          </div> -->
                          <div class="col d-flex justify-content-start align-items-center ml-lg-2 ml-md-2">
                            <div class="col-lg-6 col-md-6 col-sm-12 pt-1 pt-md-0 locInput">

                              <div class="input-group mb-3">
                                 <input
                                  type="text"
                                  name="Pin Code"
                                  data-vv-scope="location"
                                  v-validate="{ required:true, regex: /^(?!0+$)[0-9]{4,10}$/ }"
                                  data-vv-as="Pin Code"
                                  class="input-create"
                                  autocomplete="off"
                                  v-model="pinCode"
                                   maxlength="10"
                                  required
                                />

                                <span class="bar"></span>

                                  <label class="label-create required">Pin Code</label>

                                <center>
                                  <div
                                    v-if="errors.has('location.Pin Code')"
                                    class="alert-danger"
                                  >{{ errors.first('location.Pin Code') }}</div>
                                </center>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="card-footer collapse"
                    id="faq5"
                    aria-labelledby="faqhead5"
                    data-parent="#faq"
                  >
                    <div class="float-right">
                      <button class="mr-3 btn button-cancel1" @click="navigateToUserProfile">
                        <span class="proximanova">Cancel</span>
                      </button>
                      <button v-show="createLocation" class="mr-3 btn button-create sign-up-button mouseoverbtn2 borderradius20 backgroundcolorblack" :disabled="savelocation" v-on:click="saveLocationDetails" id="location">
                        <span class="button-cancel-font proximanova" >{{ (currentRoute=='createprofile') ? "Create" : "Save" }}</span>
                      </button>
                      <button v-show="!createLocation" class="mr-3 btn button-create borderradius20 backgroundcolorblack mouseoverbtn2" :disabled="savelocation" v-on:click="saveLocationDetails" id="location1">
                        <span class="button-cancel-font proximanova" >Save</span>
                      </button>
                    </div>
                  </div>
                </div>
                        </div>
            </div>
            <div class="row no-gutters ml-3 mr-3 ml-md-4 mr-lg-1 mb-3">
                        <div class="col-12">
                          <!-- skills section -->
                          <!-- user can able to add skills and technology names -->
                <div class="card">
                  <div class="card-header" id="faqhead6">
                     <div v-if="this.profileID!=null">
                    <a
                      class="btn btn-header-link collapsed proximanova-semibold"
                      data-toggle="collapse"
                      data-target="#faq6"
                      aria-expanded="true"
                      aria-controls="faq6"
                      @click="toggleActiveClass('skills')"
                    >Skills</a>
                     </div>
                     <div v-else>
                    <a
                      class="btn btn-header-link collapsed proximanova-semibold"
                      data-toggle="collapse show"
                      data-target="#faq1"
                      aria-expanded="true"
                      aria-controls="faq1"
                    >Skills</a>
                    </div>

                  </div>

                  <div id="faq6" class="collapse" aria-labelledby="faqhead6" data-parent="#faq">
                    <div class="card-body">

                      <div v-for="(skill,index) in skills" v-bind:key="index">
                        <div class="form">
                          <div v-if="skillErrorMessage" class="alert-danger text-center">
                            {{skillErrorMessage}}
                          </div>
                          <div class="row no-gutters">
                            <div class="col d-flex justify-content-start align-items-center ml-md-2">
                              <div class="col-md-6">

                                <div class="input-group mb-3">
                                  <div class="col-12 pl-0 pr-0 d-flex">
                                  <input
                                    type="text"
                                    id="knowledge"
                                    v-validate=" 'required' "
                                    name="Knowledge In"
                                    data-vv-as="Knowledge In"
                                    autocomplete="off"
                                    class="input-create col-12 pl-0"
                                    @keyup="getKnowledgeList(index)"
                                    @keypress="checkForCommaSkill"
                                    @keyup.enter="addToListKnowledge(index)"
                                    v-model="skills[index].knowledgeIn"
                                    data-role="tagsinput"
                                    required
                                  />
                                  <span class="bar"></span>
                                  <label class="label-create required">Knowledge In</label>
                                  <img src="../assets/addicon.png" @click="addToListKnowledge(index)" title="add skill" class="addSkillBtn pointer" alt="add" width="30" height="30">
                                  </div>
                                  <!-- <ul id="knowledge">
                                    <li
                                      v-for="(knowledge,index) in knowledgeList"
                                      :value="knowledge.id"
                                      :key="index"
                                      @click="addKnowledge(knowledge.knowledgeIn, knowledge, knowledge.id, index)"
                                    >{{knowledge.knowledgeIn}}</li>
                                  </ul> -->
                                  <div class="dropdown-menu col-10 d-flex" id="LocationDropdown" v-if="knowledgeList.length > 0"> 
                                    <div class="fontsize12 col-12 pl-0 pr-0 black60 proximanova pointer">
                                      <li class="list-group-item pl-3" v-for="(knowledge,index) in knowledgeList" :key="index" :value="knowledge.id" @click="addKnowledge(knowledge.knowledgeIn, knowledge, knowledge.id, index)">
                                        {{knowledge.knowledgeIn}}
                                      </li>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div v-if="selectedknowledgeListArray.length > 0" class="d-flex flex-wrap mb-3 col" >
                              <div v-for="(skill, index) in selectedknowledgeListArray" :key="index" >
                                <div class="pl-2 pr-2 mr-1 border knowledgeItem borderradius20 proximanova d-flex mt-1">
                                    {{skill.knowledgeDetails.knowledgeIn }}
                                    <span @click="removeSelectedKnowledgeItem(index, skill)" class="ml-2 black60">x</span>
                                </div>
                              </div>
                          </div>
                          <div v-if="technologyErrorMessage" class="alert-danger text-center">
                            {{technologyErrorMessage}}
                          </div>
                          <div class="row no-gutters">
                            <div class="col d-flex justify-content-start align-items-center ml-md-2">
                              <div class="col-md-6">

                                <div class="input-group mb-3">
                                  <div class="col-12 pl-0 pr-0 d-flex">
                                  <input
                                    type="text"
                                    id="technology"
                                    v-validate=" 'required' "
                                    name="Technology Tools"
                                    data-vv-as="Technology Tools"
                                    autocomplete="off"
                                    class="input-create col-12 pl-0"
                                    @keyup="getTechnologyList(index)"
                                    @keypress="checkForCommaTechnology"
                                    @keyup.enter="addToListTechnology(index)"
                                    v-model="skills[index].technologyTools"
                                    data-role="tagsinput"
                                    required
                                  />
                                  <span class="bar"></span>
                                  <label class="label-create required">Technology Tools</label>
                                  <img src="../assets/addicon.png" @click="addToListTechnology(index)" title="add technology" class="addSkillBtn pointer" alt="add" width="30" height="30">
                                  </div>
                                  <!-- <div class="bg-white w-100">
                                  <ul id="knowledge">
                                    <li
                                    class="border text-center"
                                      v-for="(technology,index) in technologyList"
                                      :value="technology.id"
                                      :key="index"
                                      @click="addTechnology(technology.technologyName, technology, technology.id, index)"
                                    >{{technology.technologyName}}</li>
                                  </ul>
                                  </div> -->
                                  <div class="dropdown-menu col-10 d-flex" id="LocationDropdown" v-if="technologyList.length > 0"> 
                                    <div class="fontsize12 col-12 pl-0 pr-0 black60 proximanova pointer">
                                      <li class="list-group-item pl-3" v-for="(technology,index) in technologyList" :key="index" :value="technology.id" @click="addTechnology(technology.technologyName, technology, technology.id, index)">
                                        {{technology.technologyName}}
                                      </li>
                                    </div>
                                  </div>
                                </div>

                              </div>
                            </div>
                          </div>
                          <div v-if="selectedTechnologyListArray.length > 0" class="d-flex flex-wrap col">
                              <div v-for="(skill, index) in selectedTechnologyListArray" :key="index" >
                                  <div class="pl-2 pr-2 mr-1 border knowledgeItem borderradius20 proximanova d-flex mt-1">
                                      {{skill.technologyDetails.technologyName}}
                                      <span @click="removeSelectedTechnologyItem(index, skill)" class="ml-2 black60">x</span>
                                  </div>
                              </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                  <div
                    class="card-footer collapse"
                    id="faq6"
                    aria-labelledby="faqhead5"
                    data-parent="#faq"
                  >
                    <!-- <div class="float-right">
                       <router-link to="/welcome" tag="a">
                      <button class="mr-3 btn button-cancel">
                        <span class="button-cancel-font">Cancel</span>
                      </button>
                       </router-link>
                      <button v-show="createSkills" class="mr-3 btn button-create" id="skillsAdd" v-on:click="saveSkills">
                        <span class="button-cancel-font">Create</span>
                      </button>
                      <button v-show="!createSkills" class="mr-3 btn button-create" id="skillsAdd1" v-on:click="saveSkills">
                        <span class="button-cancel-font">Save</span>
                      </button>
                    </div> -->
                  </div>
                </div>
                        </div>
            </div>
              </div>
            </div>
          </div>
        </div>
        <upload-profile-picture-modal v-if="showProfilePictureModal" :profilePictureObj="profilePictureObj" @closeProfilePhotoModal="closeProfilePhotoModal"></upload-profile-picture-modal>
        <div class="col middle-background">
          <div class="row no-gutters">
            <br />
          </div>
          <div class="row no-gutters">
            <br />
          </div>
           <pendingActivities />
        </div>
      </div>

    </div>
    <APIerrorModal v-if="displayAPIerrorModal" @closeAPIerrorModal="closeAPIerrorModal"></APIerrorModal>
    <no-profile-id-modal-component v-if="displayNoProfileModalComponent" @closeNoProfileIdModal="closeNoProfileIdModal"></no-profile-id-modal-component>
     <!-- <Footer class="footer d-block d-sm-block d-md-block d-lg-none" /> -->

  </div>
</template>
<script>
import topmenu from "@/components/TopHeader.vue";
import htttpuserprofile from "@/js/http-userprofile.js";
import { error, isString } from "highcharts";
import { Field } from "vee-validate";
import sidemenu from "@/components/SideMenu.vue";
import $ from "jquery";
import pendingActivities from "@/components/PendingActivities.vue";
import Vue from "vue";
import axios from "axios";
import InputTag from 'vue-input-tag'
import Footer from "../components/Footer";
import Cropper from 'cropperjs'
//import http from "@/js/http-common.js";
import Multiselect from 'vue-multiselect'
import DatePicker from 'vue2-datepicker';
import moment from 'moment'
import { bus } from "../main";
import APIerrorModal from '../components/APIerrorpopup.vue'
import uploadProfilePictureModal from '../components/UploadProfilePicture.vue'
import NoProfileIdModalComponent from '../components/NoprofileIdModal.vue'
import sessionUtils from '@/js/session-util.js'
import commonUtils from "../js/common-utils";
import htttreferral from "@/js/http-referral.js";
Vue.component('input-tag', InputTag)
export default {
  components: {
    topmenu,
    pendingActivities,
    sidemenu,
    Footer,
    Multiselect,
    DatePicker,
    uploadProfilePictureModal,
    NoProfileIdModalComponent,
    APIerrorModal
  },
  data() {
    return {
      currentRoute : 'currentRoute',
      activeClass: "basic_info",
      hiddenworkauth: true,
      pageloader : true,
      getuserid : '',
      firstname: "",
      lastname: "",
      create: true,
      gender: "",
      tags:["jessy","jerry"],
      genderList: [],
      companyname: "",
      designation: "",
      prifixusername : "@",
      username : "",
      usernamerror : '',
      validfirstname : true,
      validlastname : true,
      validcompanyname : true,
      validdesignation : true,
      aboutYou: "",
      countyCodesList : [
        {countryName : 'India', countryCode : '+91' },
        {countryName : 'USA', countryCode : '+1' }
      ],
      primaryCountryCode : '+91',
      alternateCountryCode : '+91',
      primaryMobileNumber: "",
      alternateMobileNumber: "",
      email: sessionUtils.getUserEmail(),
      tags:[],
      websiteUrl: "",
      description: "",
      countryList: [],
      citiesList: [],
      employmentTypeList: [],
      selectedMultiselectLocCountry : null,
      selectedMultiselectLocState : null,
      selectedMultiselectLocCity : null,
      country: "",
      workAuthorization: "",
      workAuthorizationList: [],
      state: "",
      city: "",
      zipCode: "",
      pinCode:"",
      profile: "",
      profilePictureName: "",
      imgSelected : false,
      //croppie image
      croppieImage: '',
      cropped: null,
      uploadphoto:"true",
      basicdisable: 'disabled',
      profileVideoName: "",
      fresherOrExperience: "",
      workLocationPreference: "",
      createEducation:true,
      createLocation:true,
      createSkills : true,
      file: "",
      basicinfo: false,
      contactinfo: false,
      showPreview: false,
      imagePreview: "",
      stateslist: [],
      typeOfDegreeList: [],
      experiencelist: [],
      testing: [],
      userdatalist: [],
      locationList: [],
      fieldList: [],
      basicCompanyList: [],
      basicDesignationList: [],
      companyList: [],
      designationList: [],
      institutionnameList: [],
      filteredInstitutes: [],
      filteredcompany:[],
      filtereddesignation:[],
      knowledgeList: [],
      technologyList: [],
      checkEducationStartDateMessage: "",
      checkEducationEndDateMessage : '',
      useraliasname : null,
      profileID: null,
      basicfirstname:"",
      role: [],
      fresher:'',
      showProfilePictureModal : false,
      displayAPIerrorModal : false,
      displayNoProfileModalComponent : false,
      profilePictureObj : {},
      profilePicLink:'',
      hidecreateprofilehome: "",
      hideeditprofile: true,
      hideprofile: false,
      checkDateMessage: "",
      checkStartDateMessage: "",
      contactdisable:"disabled",
      expsavedisable:"disabled",
      basicCompanyId: "",
      basicdesignationId: "",
      birthDate:"",
      incorrectDOB: "",
      createcontact:true,
      savelocation:false,
      filteredexpcompany:[],
      createworkexperience:true,
      filteredexpdesg:[],
      filteredfields:[],
      workStateslist:[],
      educationStateslist:[],
      workCitiesList:[],
      educationCitiesList:[],
      profileImage:[],
      experience: [
        // {
        //   company: "",
        //   companyId: "",
        //   userRoleId: "",
        //   employmentType: "",
        //   currentWorkingFlag: "",
        //   description: "",
        //   startDate: "",
        //   endDate: "",
        //   country: "",
        //   state: "",
        //   city: "",
        //   roleName: "",
        //   workStatus:'N',
        // }
      ],
      //exp data
      hidedisplayexperienceInput : false,
      selectedMultiselectExpCountry : null,
      selectedMultiselectExpState: null,
      selectedMultiselectExpCity : null,
      exp : {
        id : null,
        company: "",
        companyId: "",
        userRoleId: "",
        employmentType: "",
        currentWorkingFlag: "",
        description: "",
        startDate: "",
        endDate: "",
        country: "",
        state: "",
        city: "",
        countryObj : '',
        stateObj : '',
        cityObj : '',
        roleName: "",
        workStatus:'N',
      },
      validexpcompanyname : true,
      validexpdesignation : true,
      selectedIndex : '',
      editExpObject : false,
      AddErrorMessage : '',
      certificates: [
        // {
        //   typeOfDegreeId: "",
        //   currentStudyFlag: "",
        //   country: "",
        //   state: "",
        //   city: "",
        //   startDate: "",
        //   endDate: "",
        //   fieldOfStudy: "",
        //   fieldOfStudyId: "",
        //   institution: "",
        //   institutionid:"",
        //   studyStatus:'N'
        // }
      ],
      hidedisplayeducationInput : false,
      selectedMultiselectEduCountry : null,
      selectedMultiselectEduState : null,
      selectedMultiselectEduCity : null,
      certificatesobj : {
        id : null,
        typeOfDegreeId: "",
        currentStudyFlag: "",
        country: "",
        state: "",
        city: "",
        countryObj : '',
        stateObj : '',
        cityObj : '',
        startDate: "",
        endDate: "",
        fieldOfStudy: "",
        fieldOfStudyId: "",
        institution: "",
        institutionid:"",
        studyStatus:'N'
      },
      valideducollegename : true,
      validedufieldofstudy : true,
      selectedCertificatesIndex : '',
      editCertificatesObject : false,
      AddCertificatesErrorMessage : '',
      skills: [
        {
          knowledgeList: [],
          technologyList: [],
          technologyListId: "",
          knowledgeListId: ""
        }
      ],
      skillErrorMessage : '',
      technologyErrorMessage  :'',
      selectedknowledgeListArray : [],
      selectedknowledgeListArrayId : [],
      selectedTechnologyListArray : [],
      selectedTechnologyListArrayId : [],
      selectedFile: "",
      cropper : '',
      duplicateFlag : false,
      duplicatestudyFlag : false,
      //profile strength
      profilePercentage : null,
      profileStrengthLabel : 'Very Low',
      // userType : null,
    };
  },
  methods: {
    navigateToUserProfile : function() {   
        if(!this.profileID){
          router.push({
            name : 'welcome'
          })
        }else{
          this.$store.state.selectedUser = this.useraliasname; 
          this.$router.push({name: 'wn', params: { id: this.$store.state.selectedUser}});
        } 
    },
    closeAPIerrorModal(){
      this.displayAPIerrorModal = false;
    },
    allowOnlyNumbersandCharacters : function(event){
      var inputValue = event.charCode;
      var charCode = (typeof event.which == "undefined") ? event.keyCode : event.which;
      if (charCode <= 64 && (charCode!= 32 && charCode != 0) || (charCode > 90 && charCode < 97)) {
          event.preventDefault();
      }
    },
    checkfornumbersanddigits : function() {
      var regalphnumspace = /^[a-z\s]+$/i;
      this.validfirstname = regalphnumspace.test(this.firstname);
      this.validlastname = regalphnumspace.test(this.lastname)
      console.log("validations : ", this.validfirstname, this.validlastname, this.validcompanyname, this.validdesignation)
    },
    checkcompanycollege : function() {
      var allowalphaspecial = /^[A-Z0-9 @~`!@#$%^&*()_=+\\\\';:\"\\/?>.<,-]*$/i ;
      var regnotfirst = /^[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/ ;

      let comp = allowalphaspecial.test(this.companyname);
      if(comp){
        if(regnotfirst.test(this.companyname)){
          this.validcompanyname = false;
        }else{
          this.validcompanyname = true;
        }
      }else{
        this.validcompanyname = false;
      }
      let desig = allowalphaspecial.test(this.designation);
      if(desig){
        if(regnotfirst.test(this.designation)){
          this.validdesignation = false;
        }else{
          this.validdesignation = true;
        }
      }else{
        this.validdesignation = false;
      }
      console.log(regnotfirst.test(this.designation))
      console.log("validations company: ", this.validfirstname, this.validlastname, this.validcompanyname, this.validdesignation)
    },
    // notAllowNumbers : function(event) {
    //   var inputValue = event.charCode;
    //   //   if(!(inputValue >= 65 && inputValue <= 122) && (inputValue != 32 && inputValue != 0)){
    //   //       event.preventDefault();
    //   //   }
    //   var charCode = (typeof event.which == "undefined") ? event.keyCode : event.which;
    //   var charStr = String.fromCharCode(charCode);
    //   if (/\d/.test(charStr) && (inputValue != 32 && inputValue != 0)) {
    //       // return false;
    //       event.preventDefault();
    //   }
    // },
    // initial data rendering 
    // fetching dropdown information and also logged in user information
    fetchdata() {
      this.retriveDropdownData();
      this.getUserByID();
    },
    // this will invoke after change the data in date of birth field to check the validations
    // use cases are : 
    // age should not be greater than 100 years and also should not be less than 13 years
    dateOfBirthValidation(){
      var today = new Date();
       var nowyear = today.getFullYear();
        var nowmonth = today.getMonth();
        var nowday = today.getDate();
        var b = this.birthDate ;
        console.log(b)


        var birth = new Date(b);

        var birthyear = birth.getFullYear();
        var birthmonth = birth.getMonth();
        var birthday = birth.getDate();

        var age = nowyear - birthyear;
        var age_month = nowmonth - birthmonth;
        var age_day = nowday - birthday;


        if (age > 100) {
            this.incorrectDOB = "Entered age should be less than 100 years"
            return false;
        }
        if (age_month < 0 || (age_month == 0 && age_day < 0)) {
            age = parseInt(age) - 1;
        }
        if ((age == 13 && age_month <= 0 && age_day <= 0) || age < 13) {
            this.incorrectDOB = "Age should be more than 13 years.Please enter a valid Date of Birth";
        }
        else{
          this.incorrectDOB = ""
          // this.check()
        }
    },
    // this will invoke after click on back button in create profile page to go back to the welcome page
    gotoMainPage(){
      // if(!this.profileID){
      // remove following info from localstorage if user accessing screen from pricing screen flow
      localStorage.removeItem("selectedPlan")
      localStorage.removeItem("selectedPlanCard")
      localStorage.removeItem("billingCountry")
      ////
      // if(this.userType == 'InternalUser'){
      //   this.$router.push({
      //     name : 'coursevideos'
      //   })
      // }else{
        if(!this.profileID) {
         this.$router.push({
          name : 'welcome'
        })
        }else{
          this.$store.state.selectedUser = this.useraliasname; 
          this.$router.push({name: 'wn', params: { id: this.$store.state.selectedUser}});
        }
      // }    
    },
    // this will invoke after adding the phone number in phone number fileds in contact details section
    // set format to phone numbers
    formatCellPhoneNumber: function(event) {
      var phone = this.primaryMobileNumber;
      var alternatephone = this.alternateMobileNumber;
      if(this.primaryMobileNumber) {
      phone = phone
        .replace(/[^0-9]/g, "")
        .replace(/(\d{3})(\d{3})(\d{4})/g, "($1) $2-$3");

      this.primaryMobileNumber = phone;
      }
      if(this.alternateMobileNumber) {
      alternatephone = alternatephone
        .replace(/[^0-9]/g, "")
        .replace(/(\d{3})(\d{3})(\d{4})/g, "($1) $2-$3");
      
      this.alternateMobileNumber = alternatephone;
      }
    },
    //upload profile image modal methods
    imageModalOpen : function() {
      if(this.profileID){
      this.showProfilePictureModal = true;
      this.profilePictureObj.profilepictureLink = this.profilePicLink
      this.profilePictureObj.userId = this.getuserid;
      }else{
        this.displayNoProfileModalComponent = true;
      }
    },
    closeNoProfileIdModal(){
      this.displayNoProfileModalComponent = false;
    },
    // this will invoke after click on close button on upload profile picture modal/ sucessfully saved
    // the status will tell us wether the profile picture saved or not
    // based on the status need to update the profile picture
    closeProfilePhotoModal : function(statusObj){
      console.log("modal closed", statusObj)
      this.showProfilePictureModal = false;
      if(statusObj.status === 'SUCCESS'){
        this.updateProfilePicture()
      }
    },
    // this will trigger if the profile picture updated successfully
    // get the profile picture and set bus events to update the profile picture in all the other components (topheader/sidmenu/welcome page)
    updateProfilePicture(){
      htttpuserprofile.get('/userprofile/userbyid/'+this.getuserid)
      .then((response) => {
        this.profilePicLink = response.data.profilePictureLink;
        bus.$emit('updatingProfilePictureLink', this.profilePicLink);
      }).catch((e) => {
        console.log(e)
      })
    },
    // clearing the companies list
   clearCompanyList(){
     console.log("companylist")
     this.companyList = []
   },
   // this is on keyup event which can used to get the remaining characters that user can able to add in textarea filed in work experience description
  experiencedescription : function() {
    var textEntered, countRemaining, counter;
      textEntered = document.getElementById('exampleFormControlTextarea2').value;
      counter = (600 - (textEntered.length));
      countRemaining = document.getElementById('charactersRemaining2');
      countRemaining.textContent = counter;
  },
  // this event will trigger after adding each value in basic information section to check the form validations 
  // enable/disable buttons based on validations
  calculateTextAreaCount() {
    var textEntered, countRemaining, counter;
      textEntered = document.getElementById('exampleFormControlTextarea1').value;  
      counter = (140 - (textEntered.length));
      countRemaining = document.getElementById('charactersRemaining'); 
      countRemaining.textContent = counter;
  },
    check() {
      // var textEntered, countRemaining, counter;
      // textEntered = document.getElementById('exampleFormControlTextarea1').value;
      // counter = (400 - (textEntered.length));
      // countRemaining = document.getElementById('charactersRemaining');
      // countRemaining.textContent = counter;

     this.$validator.validateAll("addBasicinfo").then((isValid) => {
        if(isValid){
          this.basicinfo = false;
        document.getElementById("basicinfo").classList.add("backgroundcolorblack");
      } else
        document.getElementById("basicinfo").classList.remove("backgroundcolorblack");
     })

      if(this.basicdisable == true)
      {
        console.log("entered check")
         this.$validator.validateAll("addBasicinfo").then((isValid) => {
        if(isValid){
          console.log("valid")
          this.basicdisable = false
        document.getElementById("basicinfo1").classList.add("backgroundcolorblack");
      } else
        document.getElementById("basicinfo1").classList.remove("backgroundcolorblack");
     })
      }

    },
    // this will invoke after addign each value in current location section to check the validations
    // enable/disable submit button based on validations
    checkLocation(){
      this.$validator.validateAll("location").then((isValid) => {
        if(isValid){
          console.log("valid")
          document.getElementById("location").classList.add("backgroundcolorblack");
        }else{
          if(this.savelocation == true){
            this.savelocation = false
          }
          console.log("not valid")
          document.getElementById("location").classList.remove("backgroundcolorblack");
        }
      })
    },
    // this will invoke after adding company field in basic information sections
    // getting the companies list based on search text
    // validations to basic information section and  enable/disable buttons
    checkBasicCompany()
    {
      this.checkcompanycollege()
      this.basicCompanyId = '';
      this.getBasicCompanyList();
    },
    // this will invoke after adding designation field in basic information sections
    // getting the descignations list based on search text
    // validations to basic information section and  enable/disable buttons
    checkBasicDesignation()
    {
      this.checkcompanycollege()
      this.basicdesignationId = ''
       this.getBasicDesignationList();
    },
    checkUsernamevalidations() {
      var format = /^[a-zA-Z\d\_]+$/g;
      var lengthformat = /^.{8,16}$/
      var formattest = format.test(this.username);
      if(formattest){
        if(!lengthformat.test(this.username)){
          if(!this.usernamerror){
          this.usernamerror = "length should be in between 8 to 16 characters"
          }
        }else{
          if(!this.usernamerror){
          this.usernamerror = "";
          }
        }
      }else{
        if(!this.usernamerror){
        this.usernamerror = "username should contain only capital letters, small letters, numbers and symbols(_)"
        }
      }
    },
    checkusername(){
      if((this.username).length >= 3  ) {
        // let aliasname = this.prifixusername + this.username
      let aliasname = this.username  
      htttpuserprofile.get('/userprofile/checkAliasLinkExistForUser?aliasLink='+aliasname)
      .then((response) => {
        console.log("username response : ", response)
        if(response && response.data && response.data.errorCode == 1031){
          this.usernamerror = "same username is already used. try another one."
        }else{
          this.usernamerror = '';
        }
        this.checkUsernamevalidations()
      }).catch((e) => {
        console.log("username error : ", e)
      })
      }else{
        this.usernamerror = '';
        this.checkUsernamevalidations()
      }
    },
    // this event will trigger after adding each value in contact details section to check the form validations 
  // enable/disable buttons based on validations
    checkcontact(){
       this.$validator.validateAll("addContact").then((isValid) => {
        if(isValid){
          this.contactinfo =false;
        document.getElementById("contactdetails").classList.add("backgroundcolorblack");
      } else
        document.getElementById("contactdetails").classList.remove("backgroundcolorblack");
       })

       if(this.contactdisable == true){
         this.$validator.validateAll("addContact").then((isValid) => {
        if(isValid){
          this.contactdisable = false;
        document.getElementById("contactdetails1").classList.add("backgroundcolorblack");
      } else
        document.getElementById("contactdetails1").classList.remove("backgroundcolorblack");
       })
       }

    },


    // this event will trigger after adding each value in work experience section to check the form validations 
  // enable/disable buttons based on validations
    checkexperience(i){
       if(this.exp.company && this.exp.roleName && this.exp.employmentType && this.exp.country && this.exp.state && this.selectedMultiselectExpCity && this.exp.startDate && (this.exp.endDate||this.exp.workStatus=='N')){
        document.getElementById("updateWorkexpButton").classList.add("backgroundcolorblack");
        console.log("signinbutton")
      }else{
        document.getElementById("updateWorkexpButton").classList.remove("backgroundcolorblack");
        console.log("remove")
      }
    },
    // this is on keyup event which will trigger after adding each letter in company name field in work experience section
    // get the companies list based on search text
    // clearing the previous company id
    // check the validations
    checkexperiencecompany(){
      this.checkexpcompanydesignation()
      this.getWorkCompanyList()
      this.exp.companyId = ''
      // this.checkexperience()
    },
    //// validation for experince company and designation
    checkexpcompanydesignation : function() {
      var allowalphaspecial = /^[A-Z0-9 @~`!@#$%^&*()_=+\\\\';:\"\\/?>.<,-]*$/i ;
      var regnotfirst = /^[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/ ;
      let comp = allowalphaspecial.test(this.exp.company);
      if(comp){
        if(regnotfirst.test(this.exp.company)){
          this.validexpcompanyname = false;
        }else{
          this.validexpcompanyname = true;
        }
      }else{
        this.validexpcompanyname = false;
      }
      let desig = allowalphaspecial.test(this.exp.roleName);
      console.log("design : ", desig)
      if(desig){
        if(regnotfirst.test(this.exp.roleName)){
          this.validexpdesignation = false;
        }else{
          this.validexpdesignation = true;
        }
      }else{
        this.validexpdesignation = false;
      }
      console.log("experience validations company: ", this.exp.company, this.exp.roleName, this.validexpcompanyname, this.validexpdesignation)
    },
    // this is on keyup event which will trigger after adding each letter in city name field in work experience section
    // get the cities list based on search text
    // clearing the previous selected city
    // check the validations
    checkexperiencecity() {
      this.getWorkCitiesList()
      this.exp.city = ''
      // this.checkexperience()
    },
    // this is on keyup event which will trigger after adding each letter in designation field in work experience section
    // get the designations list based on search text
    // clearing the previous designation id
    // check the validations
    checkexperiencedesignation(){
      this.checkexpcompanydesignation()
      this.clearCompanyList()
      this.exp.userRoleId = ''
      this.getWorkDesignationList()
      // this.checkexperience()
    },
    // this is on keyup event which will trigger after adding each letter in city name field in education section
    // get the cities list based on search text
    // clearing the previous city
    // check the validations
    checkeducationcity : function() {
      this.getEducationCitiesList()
      this.certificatesobj.city = '';
      // this.checkinstitute()
    },
    // this is on keyup event which will trigger after adding each letter in city name field in current location section
    // get the cities list based on search text
    // clearing the previous city
    // check the validations
    checklocationcity() {
      this.getLocCities()
      this.city = '';
      //this.checkLocation()
    },
    // this will invoke after adding each value in education seactions to check the forma validations
    checkinstitute(){
       this.$validator.validateAll("edu").then((isValid) => {
        if(isValid){
        document.getElementById("updatecertificatesButton").classList.add("backgroundcolorblack");
      } else
        document.getElementById("updatecertificatesButton").classList.remove("backgroundcolorblack");
       })},
    // this is on keyup event which will trigger after adding each letter in institute name field in education section
    // get the institutes list based on search text
    // clearing the previous institute id
    // check the validations
     checkeducationinstitute(){
      this.checkeducollegefieldofstudy()
       this.certificatesobj.institutionid = '';
       this.getInstituteList()
      // this.checkinstitute()
    },
    //// validation for education college and fieldofstudy
    checkeducollegefieldofstudy : function() {
      var allowalphaspecial = /^[A-Z0-9 @~`!@#$%^&*()_=+\\\\';:\"\\/?>.<,-]*$/i ;
      var regnotfirst = /^[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/ ;
      let comp = allowalphaspecial.test(this.certificatesobj.institution);
      if(comp){
        if(regnotfirst.test(this.certificatesobj.institution)){
          this.valideducollegename = false;
        }else{
          this.valideducollegename = true;
        }
      }else{
        this.valideducollegename = false;
      }
      let desig = allowalphaspecial.test(this.certificatesobj.fieldOfStudy);
      console.log("design : ", desig)
      if(desig){
        if(regnotfirst.test(this.certificatesobj.fieldOfStudy)){
          this.validedufieldofstudy = false;
        }else{
          this.validedufieldofstudy = true;
        }
      }else{
        this.validedufieldofstudy = false;
      }
      console.log("experience validations company: ", this.valideducollegename, this.validedufieldofstudy)
    },
    // this is on keyup event which will trigger after adding each letter in field of study name field in education section
    // get the filed of study list based on search text
    // clearing the previous selected value
    // check the validations
    checkeducationField(){
      this.checkeducollegefieldofstudy()
      this.certificatesobj.fieldOfStudyId = ''
      this.getFieldOfStudyList()
      //this.checkinstitute()
      // document.getElementById('fieldname').classList.remove('d-none')
    },

    // this is on change event after changing the startdate and end date in work experience section to check the validations
    checkDate() {
      var sdate = document.getElementById("startDate").value;
      var edate = document.getElementById("endDate").value;
      // var today = new Date().toISOString().split("T")[0];
      var today = moment(new Date()).format('YYYY-MM-DD')
      if(this.exp.endDate != '') {
          if (this.exp.endDate <= this.exp.startDate) {
            this.checkDateMessage = "End Date should be greater than start date";
            document.getElementById('updateWorkexpButton').disabled = true;
            //document.getElementById("updateWorkexpButton").classList.remove("backgroundcolorblack");
          } else if (this.exp.endDate > today) {
            this.checkDateMessage = "End Date cannot be a future date";
            document.getElementById('updateWorkexpButton').disabled = true;
            //document.getElementById("updateWorkexpButton").classList.remove("backgroundcolorblack");
          } else {
            this.checkDateMessage = " ";
            document.getElementById('updateWorkexpButton').disabled = false;
            //this.checkexperience()
          }
      }

    },
    // this is onchange event in work experince startdate filed to check the following validations
    checkStartDate() {
      var sdate = document.getElementById("startDate").value;
      var today = new Date().toISOString().split("T")[0];
      console.log("sdate : ", this.exp.startDate)
      console.log("today : ", today)
      if (this.exp.startDate > today) {
        console.log("if bloack")
        this.checkStartDateMessage = "Start date cannot be a future date";
        document.getElementById('updateWorkexpButton').disabled = true;
        //document.getElementById("updateWorkexpButton").classList.remove("backgroundcolorblack");
      }
      else{
        console.log("else block")
        this.checkStartDateMessage = ""
        if(this.exp.endDate) {
          this.checkDate()
        }
        //this.checkexperience()
        document.getElementById('updateWorkexpButton').disabled = false;
      }


    },
    // this will trigger after selecting current working company status as Y 
    // clear end date and check form validtaions
    clearEndDate : function() {
      this.exp.endDate = ''
      this.checkDateMessage = '';
      //this.checkexperience()
    },
    // this will trigger after selecting current study institute status as Y 
    // clear end date and check form validtaions
    clearStudyEndDate : function() {
      this.certificatesobj.endDate = ''
      console.log(this.certificatesobj.studyStatus)
    },
    // this is onchange event in educations section startdate filed to check the following validations
    checkEducationStartDate() {
      var edustartDate = this.certificatesobj.startDate;
      // var today = new Date().toISOString().split("T")[0];
      var today = moment(new Date()).format('YYYY-MM-DD')
      if (edustartDate > today) {
        console.log("check message error")
        this.checkEducationStartDateMessage =
          "Start date cannot be a future date or todays date";
          document.getElementById('updatecertificatesButton').disabled = true;
          //document.getElementById("updatecertificatesButton").classList.remove("backgroundcolorblack");
      } else {
        this.checkEducationStartDateMessage = " ";
        document.getElementById('updatecertificatesButton').disabled = false;
        if(this.certificatesobj.endDate){
          this.checkEducationEndDate()
        }
        //this.checkinstitute()
      }

    },
    // this is on change event after changing the startdate and end date in education section to check the validations
    checkEducationEndDate() {
      var eduEndDate = this.certificatesobj.endDate;
      var edustartDate = this.certificatesobj.startDate;
      // var today = new Date().toISOString().split("T")[0];
      var today = moment(new Date()).format('YYYY-MM-DD')
      if(eduEndDate != '') {
        if (eduEndDate >= today) {
          this.checkEducationEndDateMessage = "End cannot be a future date or todays date";
          document.getElementById('updatecertificatesButton').disabled = true;
          //document.getElementById("updatecertificatesButton").classList.remove("backgroundcolorblack");
        }else {
          this.checkEducationEndDateMessage = " ";
          document.getElementById('updatecertificatesButton').disabled = false;
          //.checkinstitute()
        }
        if(eduEndDate <= edustartDate){
          this.checkEducationEndDateMessage = "End Date should be greater than start date"
          document.getElementById('updatecertificatesButton').disabled = true;
          //document.getElementById("updatecertificatesButton").classList.remove("backgroundcolorblack");
        }
      }else {
        this.checkEducationEndDateMessage = " ";
        document.getElementById('updatecertificatesButton').disabled = false;
        //this.checkinstitute()
      }

    },
    // initial retriving dropdown data
    retriveDropdownData() {
      htttpuserprofile
        .get("searchController/getIndexDetailsList", {
          params: { indexCode: 1 }
        })
        .then(response => {
          this.genderList = response.data;
          console.log(response.data);
        });
      htttpuserprofile
        .get("searchController/getIndexDetailsList", {
          params: { indexCode: 2 }
        })
        .then(response => {
          this.employmentTypeList = response.data;
          console.log(response.data);
        });
      htttpuserprofile
        .get("searchController/getIndexDetailsList", {
          params: { indexCode: 3 }
        })
        .then(response => {
          this.workAuthorizationList = response.data;
          console.log(response.data);
        });
      htttpuserprofile
        .get("searchController/getIndexDetailsList", {
          params: { indexCode: 4 }
        })
        .then(response => {
          this.typeOfDegreeList = response.data;
          console.log(response.data);
        });
      htttpuserprofile
        .get("searchController/getCountriesList")
        .then(response => {
          this.countryList = response.data;
          console.log(response.data);
        });
    },
    // this will invoke after selecting the institute from dropdown with values (which are getting by search text) in education section
    addinstitute(institute, i,ids) {
      console.log(this.certificatesobj.institution+"hello")
      console.log(i)
      this.valideducollegename = true;
      this.certificatesobj.institution = institute;
      this.certificatesobj.institutionid = ids;
      console.log("institiute name : ", this.certificatesobj.institution)
      console.log("institute is : ", this.certificatesobj.institutionid)
      // document.getElementById('instname').classList.toggle('d-none')
      this.institutionnameList = []
      //this.checkinstitute()
      //console.log(instituteName, i, this.experience);
    },
    // this will invoke after selecting the field of study from dropdown values (which are getting by search text) in education section
    addfieldOfStudy(field, i,id) {
      console.log(i)
      this.validedufieldofstudy = true;
      this.certificatesobj.fieldOfStudy = field;
      this.certificatesobj.fieldOfStudyId = id;
      // document.getElementById('fieldname').classList.toggle('d-none')
      this.fieldList=[]
      //this.checkinstitute()
    },
    // this will invoke after selecting the company from dropdown values (which are getting by search text) in experience seaction
    addexperienceOfCompany(company, i,id) {
      this.validexpcompanyname = true;
      this.exp.company = company;
      this.exp.companyId = id
      console.log("expcomapnt : ", this.exp.company)
      console.log("expcomapnyid : ", this.exp.companyId)
      // this.experience[i].company = company;
      // this.experience[i].companyId = id;
      this.companyList = []
    },
    // this will invoke after selecting the company from dropdown values (which are getting by search text) in basic information seaction
    addCompany(company,id) {
      console.log(company+"name")
      this.validcompanyname = true;
      this.companyname = company;
      this.basicCompanyId = id;
      this.basicCompanyList = [];
      // document.getElementById('basicinfocompany').classList.toggle('d-none')
    },
    // this will invoke after selecting the designation from dropdown values (which are getting by search text) in experience seaction
    addexperienceDesignation(designation, i,id) {
      this.validexpdesignation = true;
      this.exp.roleName = designation;
      this.exp.userRoleId = id;
      // this.experience[i].roleName = designation;
      // this.experience[i].userRoleId = id;
      this.designationList = []
    },
    // this will invoke after selecting the company from dropdown values (which are getting by search text) in basic information seaction
    addDesignation(designation, id) {
      this.validdesignation = true;
      this.designation = designation;
      this.basicdesignationId = id;
      this.basicDesignationList = [];
      //  document.getElementById('basicinfoDesignation').classList.toggle('d-none')
    },
    // this will invoke after selecting the knowledge from dropdown values (which are getting by search text) in skills seaction
    addKnowledge(skill, knowledge, skillId, i) {
      this.skills[0].knowledgeIn = skill;
      this.knowledgeList = [];

      //newly implemented way
      for(var i =0; i < this.selectedknowledgeListArray.length; i++) {
        if(skill.toLowerCase() === this.selectedknowledgeListArray[i].knowledgeDetails.knowledgeIn.toLowerCase()){
          this.skillErrorMessage = "Duplicate Skill record found"
          return
        }else{
          this.skillErrorMessage = ""
        }
      }
      let obj = {
        profileId : this.profileID,
        knowledgeId : skillId
      }
      htttpuserprofile.put("userprofile/updateUserKnowledge", obj)
      .then((response) => {
        console.log("successfully added knowledge : ", response)
        this.skillErrorMessage = ''
          this.selectedknowledgeListArray.push(response.data)
          this.skills[0].knowledgeIn = ''
          console.log(this.selectedknowledgeListArray);
          // this.checkSkills()
      }).catch((error) => {
        console.log(error)
        this.displayAPIerrorModal = true;
      })
      // this.skills[i].knowledgeIn = ''
      // this.selectedknowledgeListArray.push(knowledge);
      // this.selectedknowledgeListArrayId.push(skillId)
      // console.log(this.selectedknowledgeListArray)
      // console.log(this.selectedknowledgeListArrayId)
    },
    // this will invoke after selecting the technology from dropdown values (which are getting by search text) in skills seaction
    addTechnology(technology, technologyItem, technologyId,  i) {
      this.skills[0].technologyTools = technology;
      this.technologyList = [];
      for(var i =0; i < this.selectedTechnologyListArray.length; i++) {
        if(technology.toLowerCase() === this.selectedTechnologyListArray[i].technologyDetails.technologyName.toLowerCase()){
          this.technologyErrorMessage = "Duplicate Technology record found"
          return
        }else{
          this.technologyErrorMessage = ""
        }
      }
      let obj = {
       profileId: this.profileID,
       technologyId : technologyId
     }
      //newly implemented way
      htttpuserprofile.put("userprofile/updateUserTechnology", obj
     )
     .then((response) => {
       console.log("successfully added Technology : ", response)
       this.technologyErrorMessage = ''
       this.selectedTechnologyListArray.push(response.data)
        console.log(this.selectedTechnologyListArray)
        this.skills[0].technologyTools = '';
        // this.checkSkills()
     }).catch((error) => {
       console.log(error)
       this.displayAPIerrorModal = true;
     })
      // this.skills[i].technologyTools = '';
      // this.selectedTechnologyListArray.push(technologyItem);
      // this.selectedTechnologyListArrayId.push(technologyId)
      // console.log(this.selectedTechnologyListArray)
      // console.log(this.selectedTechnologyListArrayId)
    },
    // this will invoke after selecting any main sections to set active cards
    toggleActiveClass(elementId) {
      this.activeClass = elementId;
    },
    // this is initial rendering user data
    getUserByID(){
      htttpuserprofile.get('/userprofile/userbyid/'+
      sessionUtils.getUserId()).then(response =>{
      this.profileID = response.data.profileId;
        console.log(this.profileID)
        console.log(response)
        this.pageloader = false;
        //basic info
            this.getuserid = sessionUtils.getUserId()
            this.profilePicLink = response.data.profilePictureLink
            this.profileImage.push(this.profilePicLink)
            this.firstname = response.data.firstName
            this.lastname = response.data.lastName
            this.gender = response.data.gender
            // let dob = new Date(response.data.dateOfBirth)
            let dob = response.data.dateOfBirthNoTimeStamp;
            if(dob){
              // this.birthDate = dob.toISOString().split('T')[0]
              // let date = moment(dob).format();
              // console.log("dob1 : ", date)
              // this.birthDate = date.split('T')[0]
              // console.log(this.birthDate)
              // this.birthDate = moment(dob).format('YYYY-MM-DD')
              this.birthDate = moment(dob).format("MM/DD/YYYY")
            }
            if(response.data.companyDetails){
            this.companyname = response.data.companyDetails.companyName
            }
            this.basicCompanyId = response.data.companyId;
            if(response.data.designation){
            this.designation = response.data.designation.roleName
            }
            this.basicdesignationId = response.data.designationId;
            this.aboutYou = response.data.aboutYou
            this.username = response.data.aliasName;
            this.useraliasname = response.data.aliasName;
            // if(this.username){
            //   this.username = this.username.substring(1)
            // }
            //contact info
            let primaryMobileNumber = response.data.primaryPhoneNumber;
            if(primaryMobileNumber) {
              let ind1 =  primaryMobileNumber.indexOf("(")
              console.log("index : ", ind1)
              if(ind1 !== null && ind1 !== undefined && ind1 >= 0){
                this.primaryMobileNumber = primaryMobileNumber.slice(ind1)
                this.primaryCountryCode = String(primaryMobileNumber.slice(0, ind1-1))
                console.log(this.primaryMobileNumber)
                console.log(this.primaryCountryCode)
              }else{
                this.primaryMobileNumber = primaryMobileNumber
                console.log(this.primaryMobileNumber)
              }
            }else{
              this.primaryMobileNumber = null
            }    
                    
            //alternate phone number
            let alternateMobileNumber = response.data.alternatePhoneNumber
            if(alternateMobileNumber){
              let ind2 =  alternateMobileNumber.indexOf("(")
              if(ind2 !== null && ind2 !== undefined && ind2 >= 0){
                this.alternateMobileNumber = alternateMobileNumber.slice(ind2)
                this.alternateCountryCode = String(alternateMobileNumber.slice(0, ind2-1))
                console.log(this.alternateMobileNumber)
                console.log(this.alternateCountryCode)
              }else{
                this.alternateMobileNumber = alternateMobileNumber
                console.log(this.alternateMobileNumber)
              }
            }else{
              this.alternateMobileNumber = null
            }
            this.websiteUrl = response.data.websiteUrl

            //experience
            let exparray = response.data.workExperience
            console.log("exparray : ", exparray)
            if(exparray && exparray.length > 0){
            for(var e = 0; e < exparray.length; e++){
              let expobj = {}
              let compObj = exparray[e].companyDetails
              expobj.id = exparray[e].id
              expobj.company = compObj.companyName
              expobj.companyId = exparray[e].companyId
              expobj.userRoleId = exparray[e].userRoleId
              let roleObj = exparray[e].userRoles
              expobj.roleName = roleObj.roleName
              expobj.employmentType = exparray[e].employeementTypeId
              expobj.currentWorkingFlag = exparray[e].currentWorkingFlag
              expobj.description = exparray[e].description
              // expobj.startDate = new Date(exparray[e].startDate).toISOString().split('T')[0]
              expobj.startDate = moment(exparray[e].startDate).format('YYYY-MM-DD')
              if(exparray[e].currentWorkingFlag == 'Y'){
                expobj.endDate = ''
              }else{
                // expobj.endDate = new Date(exparray[e].endDate).toISOString().split('T')[0]
                expobj.endDate = moment(exparray[e].endDate).format('YYYY-MM-DD')
              }
              expobj.country = exparray[e].countryId
              expobj.countryObj = exparray[e].country
              expobj.state = exparray[e].stateId
              expobj.stateObj = exparray[e].state
              expobj.city = exparray[e].cityId
              expobj.cityObj = exparray[e].city
              expobj.workStatus = exparray[e].currentWorkingFlag

              this.experience.push(expobj)
            }
            console.log("this.experience  : ", this.experience)
            }
            //education
            let eduarray = response.data.userEducation
            // console.log("eduarray : ", eduarray)
            if(eduarray && eduarray.length > 0){
            for(var c = 0; c < eduarray.length; c++) {
              let certiobj = {}
              certiobj.id = eduarray[c].id;
              certiobj.typeOfDegreeId = eduarray[c].typeOfDegreeId;
              certiobj.currentStudyFlag = eduarray[c].currentStudyFlag
              certiobj.country = eduarray[c].countryId
              certiobj.countryObj = eduarray[c].country
              certiobj.state = eduarray[c].stateId
              certiobj.stateObj = eduarray[c].state
              certiobj.city =  eduarray[c].cityId
              certiobj.cityObj = eduarray[c].city
              // certiobj.startDate =  new Date(eduarray[c].fromDate).toISOString().split('T')[0]
              certiobj.startDate =  moment(eduarray[c].fromDate).format('YYYY-MM-DD')
              if(eduarray[c].currentStudyFlag == 'Y'){
                certiobj.endDate = ''
              }else{
                // certiobj.endDate = new Date(eduarray[c].toDate).toISOString().split('T')[0]
                certiobj.endDate = moment(eduarray[c].toDate).format('YYYY-MM-DD')
              }
              certiobj.fieldOfStudy = eduarray[c].fieldOfStudy.fieldName
              certiobj.fieldOfStudyId = eduarray[c].fieldOfStudyId
              certiobj.institution = eduarray[c].instituteDetails.instituteName
              certiobj.institutionid = eduarray[c].instituteId
              certiobj.studyStatus =  eduarray[c].currentStudyFlag

              this.certificates.push(certiobj)
            }
            console.log("this.certificates  : ", this.certificates)
            }
            //location
            this.country = response.data.countryId;
            this.selectedMultiselectLocCountry = response.data.country
            if(this.country){
            this.getStates()
            }
            this.state = response.data.stateId;
            this.selectedMultiselectLocState = response.data.state
            if(this.state){
            this.getCities()
            }
            this.city = response.data.cityId;
            if(response.data.city){
            // this.selectedMultiselectLocCity = response.data.city.cityName
            this.selectedMultiselectLocCity = response.data.city
            }
            this.workAuthorization = response.data.workAuthorization;
            // this.pinCode = response.data.zipCode
            this.pinCode = commonUtils.setPincode(response.data.zipCode)

            //skills
            let knowarray = response.data.userKnowledge
            if(knowarray && knowarray.length > 0){
            for(var i = 0; i < knowarray.length; i++) {
              this.selectedknowledgeListArray.push(knowarray[i])
            }
            }
            let techarray = response.data.userTechnology
            if(techarray && techarray.length > 0){
            for(var j = 0; j < techarray.length; j++) {
              this.selectedTechnologyListArray.push(techarray[j])
            }
            }
            //set tab view
            let activeItem = this.$session.get('activeElement')
            if(activeItem) {
              this.activeClass = activeItem
              // let list = []
              
              let list = document.getElementsByClassName(this.activeClass)
                console.log("list : ", list)
              
              // list.click()
              setTimeout(function() {
                
                list[0].click()
            },2000);
              // console.log(list[0])
              // if(list.length > 0) {
              //   for(var l = 0; l < list.length; l++) {
              //     list[l].click()
              //     console.log("list instance : ", list[l])
              //   }
              // }
            }else{
              this.activeClass = 'basic_info'
            }
            commonUtils.updateLoginUserWorkExperience(this.experience)
            //profilePercentage
            if(this.profileID !== null && this.profileID !== undefined){
              this.profilePercentage += 10; 
            }
            if(this.profilePictureLink !== '' && this.profilePictureLink !== undefined){
              this.profilePercentage += 5;
            }
            if(response.data.primaryPhoneNumber !== null && response.data.primaryPhoneNumber !== undefined) {
              this.profilePercentage += 10;
              this.$store.state.addedContactInfo = true;
            }
            if(response.data.workExperience.length > 0){
              this.profilePercentage += 20;
            }
            if(response.data.userEducation.length > 0) {
              this.profilePercentage += 10;
            }
            if(response.data.zipCode) {
              this.profilePercentage +=5;
            }
            if(response.data.userKnowledge.length > 0 && response.data.userTechnology.length > 0){
              this.profilePercentage +=10;
            }
            if(response.data.profileVideoId !== null){
              this.profilePercentage +=15;
            }
            if(response.data.resumeVideoId !== null){
              this.profilePercentage +=15
            }
            this.getprofileStrengthLabel()
      }
      ).catch((e) => {
        console.log(e)
        this.pageloader = false;
      })
    },
    // this will invoke after get the user details to set the profile strength
    getprofileStrengthLabel : function() {
      //profileStrengthLabel
      if(10 <= this.profilePercentage && this.profilePercentage <= 40){
        this.profileStrengthLabel = "Very Low"
      }else if(41 <= this.profilePercentage && this.profilePercentage <= 70){
        this.profileStrengthLabel = "Average"
      }else if(71 <= this.profilePercentage && this.profilePercentage <= 90){
        this.profileStrengthLabel = "Strong"
      }else if(91 <= this.profilePercentage && this.profilePercentage <= 100){
        this.profileStrengthLabel = "All Stars"
      }
      this.$store.state.profileStrengthPercentage = this.profilePercentage;
      this.$store.state.profileStrength = this.profileStrengthLabel;
    },
    // this will invoke after click on create button in basic information to save the final data
    saveBasicInformation() {
      var vm = this;
      this.$validator.validateAll("addBasicinfo").then((isValid) => {
        if(isValid && this.incorrectDOB=='' && this.usernamerror == '' && this.validfirstname && this.validlastname && this.validcompanyname && this.validdesignation){
          this.basicinfo = true;
        let comp = parseInt(this.company);
        let role = parseInt(this.designation);
        let compId = "";
        let compName = "";
        let desgId = "";
        let desgName = "";
        let planCardSelected = localStorage.getItem("selectedPlanCard")
        console.log(planCardSelected)
        if (this.basicCompanyId === "") {
          compName = this.companyname;
          compId = null;
        } else {
          compId = this.basicCompanyId;
          compName = null;
        }
        if (this.basicdesignationId === "") {
          desgName = this.designation;
          desgId = null;
        } else {
          desgId = this.basicdesignationId;
          desgName = null;
        }
        if(this.aboutYou){
          this.aboutYou = this.aboutYou.replace(/(?:\r\n|\r|\n)/g, "")
        }
        let dob = moment(this.birthDate).format('YYYY-MM-DD')
      let addBasicInfo = {
        userId: sessionUtils.getUserId(),
        firstName: this.firstname,
        lastName: this.lastname,
        gender: this.gender,
        aboutYou: this.aboutYou,
        dateOfBirth: dob,
        companyId: compId,
        // aliasName : this.prifixusername + this.username,
        aliasName : this.username,
        designation:{
          roleName: desgName
        },
        companyDetails:{
          companyName: compName
        },
        designationId: desgId
      };
      console.log(addBasicInfo)
      htttpuserprofile
        .post("userprofile/uploadProfileDetails/BASICINFORMATION", addBasicInfo)
        .then(response => {
          this.create = false;
          this.basicinfo = false;
          this.basicfirstname = response.data.firstName;
          this.profileID = response.data.profileId;
          this.useraliasname = response.data.aliasName;
          sessionUtils.setUserProfileId(this.profileID)
          sessionUtils.setUserAliasName(this.useraliasname)
          console.log("hello"+ this.profileID);
          this.basicdisable = true
          this.basicCompanyList = [];
          this.basicDesignationList = [];
          vm.$toast.success("Successfully Saved Basic Information")
          bus.$emit('updateProfileInformation', true);
          if(this.currentRoute=='createprofile'){
          this.updateReferCodes()
          if(planCardSelected == 'true') {
             this.$router.push({
              name : 'Premium'
            })
          }
          }
        }).catch((e) => {
          console.log(e)
          this.basicinfo = false;
          if(e.response.data.errorCode == '1007'){
            vm.$toast.error("Please enter valid user information")
          }else{
          this.displayAPIerrorModal = true;
          }
        });
        }else{
          vm.$toast.error("Please enter valid user information")
        }

      })

      //document.getElementById("basicinfo1").classList.remove("backgroundcolorblack");

    },
    updateReferCodes : function() {
      htttreferral.put('userReferral/updateUserReferralCode?profileId='+this.profileID+'&userId='+sessionUtils.getUserId())
      .then((response) => {
        console.log("update after basic referral code : ", response )
      }).catch((e) => {
        console.log(e)
      })
    },
    // this will invoke after click on create button in contact details section to save final data
    saveContactDetails() {
      var vm = this;
       this.$validator.validateAll("addContact").then((isValid) => {
        if(isValid){
          this.contactinfo = true;
      let addContactDetails = {
        userId: sessionUtils.getUserId(),
        email: this.email,
        primaryPhoneNumber: this.primaryCountryCode +' '+ this.primaryMobileNumber,
        websiteUrl: this.websiteUrl
      };
      if(this.alternateMobileNumber){
        addContactDetails.alternatePhoneNumber = this.alternateCountryCode +' '+this.alternateMobileNumber
      }else{
        addContactDetails.alternatePhoneNumber = ""
      }
      console.log(addContactDetails)
      htttpuserprofile
        .post(
          "userprofile/uploadProfileDetails/CONTACTDETAILS",
          addContactDetails
        )
        .then(response => {
          this.contactinfo = false;
          console.log(JSON.stringify(response.data));
          this.createcontact = false
          this.contactdisable = true;
          this.$store.state.addedContactInfo = true;
          vm.$toast.success("Successfully Saved Contact Information")
        }).catch((e) => {
          console.log(e)
          this.contactinfo = false;
          if(e.response.data.errorCode == '1007'){
            vm.$toast.error("Please enter valid user contact information")
          }else{
          this.displayAPIerrorModal = true;
          }
        });
        }
       })
        //document.getElementById("contactdetails1").classList.remove("backgroundcolorblack");
    },

    // this will invoke after click on create button in location section to save final data
    saveLocationDetails() {
      var vm = this;
      this.$validator.validateAll("location").then((isValid) => {
        if(isValid){
          this.savelocation = true;
          if(this.country !== 233){
            this.workAuthorization = ''
          }
      let addLocationDetails = {
        userId: sessionUtils.getUserId(),
        countryId: this.country,
        workAuthorization: this.workAuthorization,
        stateId: this.state,
        // cityId: this.city,
        zipCode: this.pinCode,
        workLocationPreference: "Y"
      };
      if(this.city !== '') {
        addLocationDetails.cityId = this.city
      }else{
        addLocationDetails.cityId = null;
        addLocationDetails.city =  {
          cityId: null,
          cityName : this.selectedMultiselectLocCity,
          stateCode : addLocationDetails.stateId
        }
      }
      console.log("location details : ", addLocationDetails)
      htttpuserprofile
        .post("userprofile/uploadProfileDetails/LOCATION", addLocationDetails)
        .then(response => {
          console.log("hello");
          this.createLocation = false
          this.savelocation = false
          vm.$toast.success("Successfully Saved Location Information")
        }).catch((e) => {
          console.log(e)
          this.savelocation = false;
          if(e.response.data.errorCode == '1007'){
            vm.$toast.error("Please enter valid user location information")
          }else{
          this.displayAPIerrorModal = true;
          }
        });
        }
      })
    },
    // this will invoke after selecting country from country dropdown in current location
    onSelectLocCountry : function(option) {
      this.country = option.countryId
      this.getStates()
    },
    // get states based on selected country in current location section
    getStates() {
      this.selectedMultiselectLocState = null;
      this.selectedMultiselectLocCity = null;
      this.city ='',
      this.citiesList =[],
      this.state = '',
      this.stateslist = []
      htttpuserprofile
        .get("searchController/getStatesList", {
          params: { countryCode: this.country }
        })
        .then(response => {
          this.stateslist = response.data;
          console.log(response.data);
        });
       // this.checkLocation()
    },
    // this will invoke after selecting country from country dropdown in experience
    onSelectExpConytry : function(option) {
      this.exp.country = option.countryId;
      this.getWorkStates()
    },
    // get states based on selected country in work experience section
    getWorkStates() {
      //clear states and cities
      this.exp.state = '',
      this.workStateslist = [],
      this.exp.city = '',
      this.workCitiesList = []
      this.selectedMultiselectExpState = null;
      this.selectedMultiselectExpCity = null;
      htttpuserprofile
        .get("searchController/getStatesList", {
          params: { countryCode: this.exp.country}
        })
        .then(response => {
          this.workStateslist = response.data;
          console.log(response.data);

        });
    },
    // this will invoke after selecting country in educations section
    onSelectEduCountry : function(option) {
      this.certificatesobj.country = option.countryId;
      this.getEducationStates()
    },
    // getting states list based on selected country in educations section
    getEducationStates(){
      this.selectedMultiselectEduState = null;
      this.selectedMultiselectEduCity = null;
      this.certificatesobj.city = '';
      this.certificatesobj.state = '';
      this.educationStateslist = [];
      this.educationCitiesList = [];
       htttpuserprofile
        .get("searchController/getStatesList", {
          params: { countryCode: this.certificatesobj.country }
        })
        .then(response => {
          this.educationStateslist = response.data;
          console.log(response.data);
        });

    },
    // this will invoke after selecting city from cities list (which are getting by search text) in current location section
    // check validations
    //before multiselect
    // onSelectLocCity : function(cityName, i, cityId) {
    //   this.city = cityId
    //   this.selectedMultiselectLocCity = cityName;
    //   this.citiesList =[],
    //   this.checkLocation()
    // },
    onSelectLocCity : function(option) {
      this.city = option.cityId
      this.selectedMultiselectLocCity = option;
     // this.checkLocation()
    },
    // this will invoke after selcting state from states dropdown in current location section
    onSelectLocState : function(option) {
      this.state = option.stateId;
      this.city = '';
      this.selectedMultiselectLocCity = ''
      this.citiesList = [];
      this.getCities()
    },
    getCities() {
      this.selectedMultiselectLocCity = null;
      this.city = '';
      this.citiesList = [];
      htttpuserprofile
        .get("searchController/getCitiesList", {
          params: { stateCode: this.state }
        })
        .then(response => {
          this.citiesList = response.data;
          console.log(response.data);
        });
       // this.checkLocation()
    },
    onSelectExpCity : function(option) {
      // this.exp.city = option.cityId
      this.exp.city = option.cityId;
      this.selectedMultiselectExpCity = option;
      //this.checkexperience()
    },
    // this will invoke after selcting state from states dropdown in work experience section
    onSelectExpState : function(option) {
      this.exp.state = option.stateId;
      this.exp.city = '';
      this.selectedMultiselectExpCity = null
      this.getWorkCities()
    },
    // not in used
    getWorkCities() {
      this.exp.city = '';
      this.workCitiesList = [];
      this.selectedMultiselectExpCity = null;
      htttpuserprofile
        .get("searchController/getCitiesList", {
          params: { stateCode: this.exp.state }
        })
        .then(response => {
          this.workCitiesList = response.data;
          console.log(response.data);

        });

    },
    onSelectEduCity : function(option) {
      // this.certificatesobj.city = option.cityId
      this.certificatesobj.city = option.cityId;
      this.selectedMultiselectEduCity = option;
      //this.checkinstitute()
    },
    // this will invoke after selcting state from states dropdown in education section
    onSelectEduState : function(option) {
      this.certificatesobj.state = option.stateId;
      this.getEducationCities()
      this.certificatesobj.city = '';
      this.selectedMultiselectEduCity = null
    },
     getEducationCities() {
       this.selectedMultiselectEduCity = null;
       this.certificatesobj.city = '';
       this.educationCitiesList = [];
      htttpuserprofile
        .get("searchController/getCitiesList", {
          params: { stateCode: this.certificatesobj.state }
        })
        .then(response => {
          this.educationCitiesList = response.data;
          console.log(response.data);
        });
    },
    // fetching institutes list based on search text (education seactiion)
   getInstituteList() {
     if((this.certificatesobj.institution).length >= 3)
     {
      htttpuserprofile
        .get("searchController/searchByInstituteName",{params:{instituteName:this.certificatesobj.institution}}).then(response => {
          this.institutionnameList = response.data;
          console.log(response.data)
        });
     }else{
       this.institutionnameList = []
     }
    },
    //fetching field of study list based on search text (education seaction)
   getFieldOfStudyList() {
       if((this.certificatesobj.fieldOfStudy).length >= 3)
     {
      htttpuserprofile
        .get("searchController/searchByFieldName",{params:{fieldName:this.certificatesobj.fieldOfStudy}}).then(response => {
          this.fieldList = response.data;
          console.log(response.data)
        });
     }else{
       this.fieldList = []
     }
    },
    // fetching companies list based on search text (basic information section)
    getBasicCompanyList() {
      if((this.companyname).length >=3)
      {
      htttpuserprofile
        .get("searchController/searchByCompanyName",{params: {companyName:this.companyname}})
        .then(response => {
          this.basicCompanyList = response.data;
        });
      }else{
        this.basicCompanyList = [];
      }
    },

    // fetching companies list based on search text (work experience section)
    getWorkCompanyList() {
      if((this.exp.company).length >= 3) {
        htttpuserprofile
          .get("searchController/searchByCompanyName",{params: {companyName:this.exp.company}})
          .then(response => {
            this.companyList = response.data;
          });
        }else{
          this.companyList = [];
        }
    },
    // fetching cities list based on search text (education section)
    getEducationCitiesList() {
      this.certificatesobj.city = '';
      if((this.selectedMultiselectEduCity).length >= 3) {
        htttpuserprofile
          .get("searchController/searchbyLocation?stateCode="+this.certificatesobj.state,
          { params: {
            searchText:this.selectedMultiselectEduCity
            }
          }
          ).then(response => {
            this.educationCitiesList = response.data;
            console.log("getting edu cities : ", this.educationCitiesList)
          });
        }else{
          this.educationCitiesList = [];
        }
    },
    // fetching cities list based on search text (work experience section)
    getWorkCitiesList() {
      this.exp.city = '';
      if((this.selectedMultiselectExpCity).length >= 3) {
        htttpuserprofile
          .get("searchController/searchbyLocation?stateCode="+this.exp.state,
          { params: {
            searchText:this.selectedMultiselectExpCity
            }
          }
          ).then(response => {
            this.workCitiesList = response.data;
            console.log("getting cities : ", this.workCitiesList)
          });
        }else{
          this.workCitiesList = [];
        }
    },
    // fetching cities list based on search text (current location section)
    getLocCities() {
      this.exp.city = '';
      if((this.selectedMultiselectLocCity).length >= 3) {
        htttpuserprofile
          .get("searchController/searchbyLocation?stateCode="+this.state,
          { params: {
            searchText:this.selectedMultiselectLocCity
            }
          }
          ).then(response => {
            this.citiesList = response.data;
            console.log("getting cities : ", this.citiesList)
          });
      }else{
        this.citiesList = [];
      }
    },
    // fetching designations list based on search text (work experience section)
    getWorkDesignationList() {
      if((this.exp.roleName).length >= 3) {
        htttpuserprofile
        .get("searchController/searchByRoleType",{params: {roleType:this.exp.roleName}})
        .then(response => {
          this.designationList = response.data;
        });
      }else{
        this.designationList = [];
      }
    },
    // fetching designations list based on search text (basic information section)
    getBasicDesignationList() {
      if((this.designation).length >= 3  ){
      htttpuserprofile
        .get("searchController/searchByRoleType",{params: {roleType:this.designation}})
        .then(response => {
          this.basicDesignationList = response.data;
        });
      }else{
        this.basicDesignationList = [];
      }
    },
    // this is keyup enter event which is using to save knowledge item
    // check if there is any duplicate skill is present or not
   addToListKnowledge : function(index) {
     console.log("will check once")
     this.knowledgeList = [];
     var vm = this;
     if(this.skills[index].knowledgeIn){
     for(var i =0; i < this.selectedknowledgeListArray.length; i++) {
       if(this.skills[index].knowledgeIn.toLowerCase() === this.selectedknowledgeListArray[i].knowledgeDetails.knowledgeIn.toLowerCase()){
         this.skillErrorMessage = "Duplicate Skill record found"
         return
       }else{
         this.skillErrorMessage = ""
       }
     }
     let obj = {
       profileId: this.profileID,
       knowledgeDetails : {
        knowledgeIn : this.skills[index].knowledgeIn
      }
     }
     htttpuserprofile.put("userprofile/updateUserKnowledge", obj
     )
     .then((response) => {
       console.log("successfully added knowledge : ", response)
       this.skillErrorMessage = '';
       this.selectedknowledgeListArray.push(response.data)
        console.log(this.selectedknowledgeListArray);
        this.skills[index].knowledgeIn = '';
        vm.$toast.success("Successfully Saved Knowledge")
        // this.checkSkills()
     }).catch((error) => {
       console.log(error)
        this.displayAPIerrorModal = true;
     })
     }
   },
   //not in used
   checkSkills : function() {
     if(this.selectedknowledgeListArray.length > 0 && this.selectedTechnologyListArray.length > 0) {
       document.getElementById("skillsAdd").classList.add("backgroundcolorblack");
     }else{
       document.getElementById("skillsAdd").classList.remove("backgroundcolorblack");
     }
   },
   // this will invoke after click on close button on saved knowledge item to delete
   removeSelectedKnowledgeItem : function(index, skill){
     console.log(skill)
     this.skillErrorMessage = '';
     this.technologyErrorMessage = '';
     var vm = this;
     htttpuserprofile.delete("userprofile/deleteUserKnowledge/"+skill.id)
     .then((response) => {
       console.log("successfully deleted : ",response)
       vm.$toast.success("Successfully Deleted knowledge")
       this.selectedknowledgeListArray.splice(index, 1)
     }).catch((error) => {
       console.log(error)
        this.displayAPIerrorModal = true;
     })
   },
   // this is keyup enter event which is using to save technology item
    // check if there is any duplicate technology is present or not
   addToListTechnology : function(index) {
     console.log("will check once")
     this.technologyList = [];
     var vm = this;
     if(this.skills[index].technologyTools){
     for(var i =0; i < this.selectedTechnologyListArray.length; i++) {
       if(this.skills[index].technologyTools.toLowerCase() === this.selectedTechnologyListArray[i].technologyDetails.technologyName.toLowerCase()){
         this.technologyErrorMessage = "Duplicate Technology record found"
         return
       }else{
         this.technologyErrorMessage = ""
       }
     }
      let obj = {
       profileId: this.profileID,
       technologyDetails : {
          technologyName : this.skills[index].technologyTools
        }
     }
     htttpuserprofile.put("userprofile/updateUserTechnology", obj
     )
     .then((response) => {
       console.log("successfully added Technology : ", response)
       this.technologyErrorMessage = ''
       this.selectedTechnologyListArray.push(response.data)
        console.log(this.selectedTechnologyListArray)
        this.skills[index].technologyTools = '';
        vm.$toast.success("Successfully Saved Technology")
        // this.checkSkills()
     }).catch((error) => {
       console.log(error)
        this.displayAPIerrorModal = true;
     })
     }
   },
   // this will invoke after click on close button on saved technology item to delete
   removeSelectedTechnologyItem : function(index, skill){
     this.skillErrorMessage = '';
     this.technologyErrorMessage = '';
     var vm = this;
      htttpuserprofile.delete("userprofile/deleteUserTechnology/"+skill.id)
     .then((response) => {
       console.log("successfully deleted : ",response)
       vm.$toast.success("Successfully Deleted Technology")
       this.selectedTechnologyListArray.splice(index, 1)
     }).catch((error) => {
       console.log(error)
        this.displayAPIerrorModal = true;
     })
   },
   // this is keyup event to get knowledge items list based on search text
   getKnowledgeList(index) {
     if(this.skills[index].knowledgeIn.length >= 3  ) {
       htttpuserprofile
        .get("searchController/searchByKnowledgeIn",{params: {knowledgeIn:this.skills[index].knowledgeIn}})
        .then(response => {
          this.knowledgeList = response.data;
          console.log("get check", this.knowledgeList)
        });
     }else{
       this.knowledgeList = []
     }

    },
    // this is keyup event to get technology items list based on search text
   getTechnologyList(index) {
     if(this.skills[index].technologyTools.length >= 3  ) {
      htttpuserprofile
        .get("searchController/searchByTechnologyName",{params: {technologyName:this.skills[index].technologyTools}})
        .then(response => {
          this.technologyList = response.data;
          console.log("get check tech  : ", this.technologyList)
        });
     }else{
       this.technologyList = []
     }
    },
    checkForCommaSkill(event) {
      this.skillErrorMessage = '';
      this.technologyErrorMessage = '';
      var key = event.keyCode || event.which;
      key = String.fromCharCode(key);
      var regex = /[^,;]+$/;
      if (!regex.test(key)) {
        this.skillErrorMessage = "Should not add multiple skills at a time with comma(,) / Semicolons(;) seperator"
        event.preventDefault();
        //this.addToListKnowledge(0)
      }
    },
    checkForCommaTechnology(event){
      this.skillErrorMessage = '';
      this.technologyErrorMessage = '';
      var key = event.keyCode || event.which;
      key = String.fromCharCode(key);
      var regex = /[^,;]+$/;
      if (!regex.test(key)) {
        this.technologyErrorMessage = "Should not add multiple Technologies at a time with comma(,) / Semicolons(;) seperator"
        event.preventDefault();
        // this.addToListTechnology(0)
      }
    },
    //this will invoke after click on add more experience button to add new experieneces
    addExperience: function() {
      this.createworkexperience = true;
      this.hidedisplayexperienceInput = true;
      this.expsavedisable = false;
      this.selectedIndex = '';
    },
    //this will invoke after click on cancel button on experience form to clear every selected values from the form
    clearExpObject : function() {
          this.editExpObject = false
          this.hidedisplayexperienceInput = false
          this.selectedIndex = ''
          this.AddErrorMessage = ''
          //clear
          this.exp.id = null
          this.exp.company =  "";
          this.exp.companyId = "";
          this.exp.userRoleId= "";
          this.exp.employmentType =  "";
          this.exp.currentWorkingFlag = "";
          this.exp.description = "";
          this.exp.startDate = "";
          this.exp.endDate = "";
          this.exp.country = "";
          this.exp.state = "";
          this.exp.city = "";
          this.exp.roleName = "";
          this.exp.workStatus ='N';
          this.exp.countryObj = '';
          this.exp.stateObj = '';
          this.exp.cityObj = '';
          this.selectedMultiselectExpCountry = null;
          this.selectedMultiselectExpState = null;
          this.selectedMultiselectExpCity = null;
          this.designationList = [];
          this.companyList = [];
          //clear selected color once updated
          let compSec = document.getElementsByClassName('exp')
          for(var i=0; i < compSec.length; i++){
            compSec[i].style.backgroundColor = "white"
          }
    },
    // this will invoke after click on edit button on saved experience cards to edit that selected experience item
    editExperience : function(index) {
          this.editExpObject = true
          let currentobj = this.experience[index];
          this.selectedIndex = index
          this.hidedisplayexperienceInput = true;
        //append current object to the binded data object
          this.exp.id = currentobj.id;
          this.exp.company =  currentobj.company;
          this.exp.companyId = currentobj.companyId;
          this.exp.userRoleId= currentobj.userRoleId;
          this.exp.employmentType =  currentobj.employmentType;
          this.exp.currentWorkingFlag = currentobj.currentWorkingFlag;
          this.exp.description = currentobj.description;
          this.exp.startDate = currentobj.startDate;
          this.exp.endDate = currentobj.endDate;
          this.exp.country = currentobj.country;
          this.selectedMultiselectExpCountry = currentobj.countryObj;
          this.getWorkStates();
          this.selectedMultiselectExpState = currentobj.stateObj;
          this.exp.state = currentobj.state;
          this.getWorkCities();
          // this.selectedMultiselectExpCity = currentobj.cityObj.cityName
          this.selectedMultiselectExpCity = currentobj.cityObj
          this.exp.city = currentobj.city;
          this.exp.roleName = currentobj.roleName;
          this.exp.workStatus =currentobj.workStatus;

          //change the color of the selected company section
          let compSec = document.getElementsByClassName('exp')
          for(var i=0; i < compSec.length; i++){
            if(i == index) {
              compSec[i].style.backgroundColor = '#DDDFE5'
            }else{
              compSec[i].style.backgroundColor = "white"
            }
          }

    },
    // this willl trigger once click on create button to save the experience
    // for create and update work experinec using the same method
    // if successfully saved get updated work experience list
    // clear the form data
    updateExpObject : function() {
      console.log("expobj : ", this.exp)
      var vm = this;
      this.$validator.validateAll("exp").then((isValid) => {
        if(isValid && this.validexpcompanyname && this.validexpdesignation){
          console.log("make api call to update")
          document.getElementById('updateWorkexpButton').disabled = true;
          document.getElementById('updateWorkexpButton').style.opacity = '0.5';
          let enddate = "";
          if(this.exp.description){
            this.exp.description = this.exp.description.replace(/(?:\r\n|\r|\n)/g, "")
          }
          let sdate = this.exp.startDate;
          let fstartD = sdate.substr(0, 7)+'-02'
          let edate = this.exp.endDate;
          let fendD = ''
          if(this.exp.workStatus !== 'Y') {
            console.log(this.exp.workStatus)
            fendD = edate.substr(0, 7)+'-02'
            fendD = moment(fendD).format()
          }else{
            console.log(this.exp.workStatus)
          }
          let object = {
            id : null,
            profileId : this.profileID,
            employeementTypeId: this.exp.employmentType,
            currentWorkingFlag: this.exp.workStatus,
            // startDate: this.exp.startDate,
            // endDate: this.exp.endDate,
            startDate : moment(fstartD).format(),
            endDate : fendD,
            description: this.exp.description,
            // cityId : this.exp.city,
            stateId : this.exp.state,
            countryId : this.exp.country
          }
          if(this.exp.id) {
            object.id = this.exp.id
          }
          if(this.exp.companyId != '') {
            object.companyId = this.exp.companyId
          }else{
            let companyDetails = { companyName :  this.exp.company }
            object.companyDetails = companyDetails
          }
          if(this.exp.userRoleId != ''){
            object.userRoleId = this.exp.userRoleId
          }else{
            let userRoles = {roleName : this.exp.roleName}
            object.userRoles = userRoles
          }

          if(!this.exp.workStatus ){
            object.currentWorkingFlag = 'N'
          }
          if(!this.exp.description) {
            object.description = ''
          }
          if(this.exp.workStatus != "Y")
          {
            enddate = this.exp.endDate;
          }
          if(this.exp.city !== '') {
            object.cityId = this.exp.city
          }else{
            object.cityId = null;
            object.city =  {
              cityId: null,
              cityName : this.selectedMultiselectExpCity,
              stateCode : object.stateId
            }
          }
          console.log("update button object : ", object)
          this.AddErrorMessage = ''
          htttpuserprofile.put("userprofile/updateWorkExperince",
            object
          ).then(response => {
            console.log("successfully updated : ", response.data);
            this.createworkexperience = false
            this.expsavedisable = true;
            document.getElementById('updateWorkexpButton').disabled = false;
            //document.getElementById('updateWorkexpButton').style.opacity = '1';
            this.updatedExpList()
            this.hidedisplayexperienceInput = false;
            // this.setUpdatedExpObject(response.data)
            this.clearExpObject();
            //clear selected color once updated
            let compSec = document.getElementsByClassName('exp')
            for(var i=0; i < compSec.length; i++){
              compSec[i].style.backgroundColor = "white"
            }
            vm.$toast.success("Successfully Saved Work experience")
          }).catch((error) => {
            console.log(error)
            document.getElementById('updateWorkexpButton').disabled = false;
            if(error.response.data.errorCode == '1007'){
              vm.$toast.error("Please enter valid user experience information")
            }else{
            this.displayAPIerrorModal = true;
            }
          })
          }else{
          // this.AddErrorMessage = 'Please fill all fields'
          vm.$toast.error("Please enter valid user experience information")
        }
        })
    },
    // this will invoke after successfully saved/updated work experince to get the latest updated records
    updatedExpList : function(){
      htttpuserprofile.get('/userprofile/userbyid/'+
      sessionUtils.getUserId()).then(response =>{
        //experience
        let exparray = response.data.workExperience;
        var updatedExpArray = []
        console.log("exparray : ", exparray)
        for(var e = 0; e < exparray.length; e++){
          let expobj = {}
          expobj.id =  exparray[e].id
          let compObj = exparray[e].companyDetails
          expobj.company = compObj.companyName
          expobj.companyId = exparray[e].companyId
          expobj.userRoleId = exparray[e].userRoleId
          let roleObj = exparray[e].userRoles
          expobj.roleName = roleObj.roleName
          expobj.employmentType = exparray[e].employeementTypeId
          expobj.currentWorkingFlag = exparray[e].currentWorkingFlag
          expobj.description = exparray[e].description
          // expobj.startDate = new Date(exparray[e].startDate).toISOString().split('T')[0]
          expobj.startDate = moment(exparray[e].startDate).format('YYYY-MM-DD')
          if(exparray[e].currentWorkingFlag == 'Y'){
            expobj.endDate = ''
          }else{
            // expobj.endDate = new Date(exparray[e].endDate).toISOString().split('T')[0]
            expobj.endDate = moment(exparray[e].endDate).format('YYYY-MM-DD')
          }
          expobj.country = exparray[e].countryId
          expobj.countryObj = exparray[e].country
          expobj.state = exparray[e].stateId
          expobj.stateObj = exparray[e].state
          expobj.city = exparray[e].cityId
          expobj.cityObj = exparray[e].city
          expobj.workStatus = exparray[e].currentWorkingFlag
          updatedExpArray.push(expobj)
        }
        this.experience = updatedExpArray;
        commonUtils.updateLoginUserWorkExperience(this.experience)
      })
    },
    // this will invoke after click on delete button on delete confirmation modal
    // clear the deleted item from the experiences list
    deleteExperience : function() {
      console.log("delete experience : ", this.selectedIndex)
      console.log(this.experience[this.selectedIndex])
      var vm = this;
      htttpuserprofile.delete("userprofile/deleteByUserWorkExperienceId/"+this.experience[this.selectedIndex].id)
      .then((response) => {
        console.log("successfully deleted : ", response)
        $('#deleteExpModal').modal('hide')
        vm.$toast.success("Successfully deleted Work experience")
        this.experience.splice(this.selectedIndex, 1);
        this.clearExpObject();
        // if (this.selectedIndex === 0) this.addExperience();
        this.selectedIndex = ''
        //clear selected color once updated
        let compSec = document.getElementsByClassName('exp')
        for(var i=0; i < compSec.length; i++){
          compSec[i].style.backgroundColor = "white"
        }
        commonUtils.updateLoginUserWorkExperience(this.experience)
        if(this.experience.length < 1){
          this.profilePercentage -= 20;
          this.getprofileStrengthLabel()
        }
      }).catch((error) => {
        console.log(error)
        $('#deleteExpModal').modal('hide')
        this.displayAPIerrorModal = true;
      })
    },
    // this will invoke after closing the delete experience confirmation modal to clear the selected index which is meant to delete
    clearSelectedIndex : function() {
      this.selectedIndex = ''
    },
    // this will invoke after click on delete button on saved experience items
    deleteExperienceModal: function(index) {
      console.log(index)
      this.selectedIndex = index;
    },
    // this will invoke after click on cancel button on eductaion form
    // clear all the filled information from the from data
    clearcertificationsObject : function() {
          this.selectedCertificatesIndex = '';
          this.editCertificatesObject = false;
          this.hidedisplayeducationInput = false;
          this.AddCertificatesErrorMessage = '';
          //clear
          this.certificatesobj.id = null
          this.certificatesobj.typeOfDegreeId =  "";
          this.certificatesobj.currentStudyFlag = "";
          this.certificatesobj.country= "";
          this.certificatesobj.state =  "";
          this.certificatesobj.city = "";
          this.certificatesobj.startDate = "";
          this.certificatesobj.endDate = "";
          this.certificatesobj.fieldOfStudy = "";
          this.certificatesobj.fieldOfStudyId = "";
          this.certificatesobj.institution = "";
          this.certificatesobj.institutionid = "";
          this.certificatesobj.studyStatus = "";
          this.certificatesobj.countryObj = '';
          this.certificatesobj.stateObj = '';
          this.certificatesobj.cityObj = '';
          this.selectedMultiselectEduCountry = null;
          this.selectedMultiselectEduState = null;
          this.selectedMultiselectEduCity = null;
          this.institutionnameList = [];
          this.fieldList = []
          //clear selected color once updated
          let certisec = document.getElementsByClassName('educat')
          for(var i=0; i < certisec.length; i++){
            certisec[i].style.backgroundColor = "white"
          }
    },
    // this will invoke after click on add more certifications button in education section
    addCertification: function() {
      this.hidedisplayeducationInput = true
      this.selectedCertificatesIndex = ''
    },
    //this will invoke after click on edit button in saved certification items
    editCertification : function(index) {
        this.editCertificatesObject = true;
        this.hidedisplayeducationInput = true;
        let currentObj = this.certificates[index]
        console.log(currentObj)
        this.selectedCertificatesIndex = index;
        this.certificatesobj.id = currentObj.id;
        this.certificatesobj.typeOfDegreeId =  currentObj.typeOfDegreeId;
        this.certificatesobj.currentStudyFlag = currentObj.studyStatus;
        this.certificatesobj.country= currentObj.country;
        this.selectedMultiselectEduCountry = currentObj.countryObj
        this.getEducationStates()
        this.certificatesobj.state =  currentObj.state;
        this.selectedMultiselectEduState = currentObj.stateObj;
        this.getEducationCities()
        this.certificatesobj.city = currentObj.city;
        // this.selectedMultiselectEduCity = currentObj.cityObj.cityName
        this.selectedMultiselectEduCity = currentObj.cityObj
        this.certificatesobj.startDate = currentObj.startDate;
        this.certificatesobj.endDate = currentObj.endDate;
        this.certificatesobj.fieldOfStudy = currentObj.fieldOfStudy;
        this.certificatesobj.fieldOfStudyId = currentObj.fieldOfStudyId;
        this.certificatesobj.institution = currentObj.institution;
        this.certificatesobj.institutionid = currentObj.institutionid;
        this.certificatesobj.studyStatus = currentObj.studyStatus;
        //change the color of the selected company section
          let compSec = document.getElementsByClassName('educat')
          for(var i=0; i < compSec.length; i++){
            if(i == index) {
              compSec[i].style.backgroundColor = '#DDDFE5'
            }else{
              compSec[i].style.backgroundColor = "white"
            }
          }
    },
    // this will invoke aftre click on create/update button on education form to add/update certification record
    // after sucessfully saved update certification records
    // clear form data
    updatecertificationsObject  :function() {
      var vm = this;
      console.log("certifiactes object : ", this.certificatesobj)
      this.$validator.validateAll("edu").then((isValid) => {
        if(isValid && this.valideducollegename && this.validedufieldofstudy){
          console.log("Saving certifications")
          document.getElementById('updatecertificatesButton').disabled = true;
          this.AddCertificatesErrorMessage = ''
          let sdate = this.certificatesobj.startDate;
          let fstartD = sdate.substr(0, 7)+'-02'
          let edate = this.certificatesobj.endDate;
          let fendD = ''
          if(this.certificatesobj.studyStatus !== 'Y') {
            console.log(this.certificatesobj.studyStatus)
            fendD = edate.substr(0, 7)+'-02'
            fendD = moment(fendD).format()
          }else{
            console.log(this.certificatesobj.studyStatus)
          }
          let object = {
            id : null,
            profileId : this.profileID,
            typeOfDegreeId : this.certificatesobj.typeOfDegreeId,
            currentStudyFlag: this.certificatesobj.studyStatus,
            // fromDate: this.certificatesobj.startDate,
            // toDate: this.certificatesobj.endDate,
            fromDate: moment(fstartD).format(),
            toDate: fendD,
            countryId : this.certificatesobj.country,
            stateId : this.certificatesobj.state,
            // cityId : this.certificatesobj.city
          }
          if(this.certificatesobj.id) {
            object.id = this.certificatesobj.id
          }
          console.log("institution id : ", this.certificatesobj.institutionid)
          if(this.certificatesobj.institutionid != '') {
            object.instituteId = this.certificatesobj.institutionid
          }else{
            let instituteDetails = { instituteName :  this.certificatesobj.institution }
            object.instituteDetails = instituteDetails
          }
          if(this.certificatesobj.fieldOfStudyId != ''){
            object.fieldOfStudyId = this.certificatesobj.fieldOfStudyId
          }else{
            let fieldOfStudy = {fieldName : this.certificatesobj.fieldOfStudy}
            object.fieldOfStudy = fieldOfStudy
          }
          if(!this.certificatesobj.studyStatus ){
            object.currentStudyFlag = 'N'
          }
          if(this.certificatesobj.studyStatus == 'Y'){
            object.toDate = ''
          }
          if(this.certificatesobj.city !== '') {
            object.cityId = this.certificatesobj.city
          }else{
            object.cityId = null;
            object.city =  {
              cityId: null,
              cityName : this.selectedMultiselectEduCity,
              stateCode : object.stateId
            }
          }
          console.log("final object for submission : ", object)
          htttpuserprofile.put("userprofile/updateUserEducation",
              object
          ).then(response => {
            console.log("successfully updated", response.data);
            vm.$toast.success("Successfully Saved Education")
            document.getElementById('updatecertificatesButton').disabled = false;
            this.updateEducationList()
            this.clearcertificationsObject()
            // this.createEducation = false
          }).catch((error) => {
            console.log(error)
            document.getElementById('updatecertificatesButton').disabled = false;
            if(error.response.data.errorCode == '1007'){
              vm.$toast.error("Please enter valid user education information")
            }else{
            this.displayAPIerrorModal = true;
            }
          })
        }else{
          // this.AddCertificatesErrorMessage = 'Please Fill all fields'
          vm.$toast.error("Please enter valid user education information")
        }
      })
    },
    // after successfully saved certification get latest latest records to update
    updateEducationList : function() {
      htttpuserprofile.get('/userprofile/userbyid/'+
      sessionUtils.getUserId()).then(response =>{
        //education
        this.certificates = []
        let eduarray = response.data.userEducation
        for(var c = 0; c < eduarray.length; c++) {
          let certiobj = {}
          certiobj.id = eduarray[c].id;
          certiobj.typeOfDegreeId = eduarray[c].typeOfDegreeId;
          certiobj.currentStudyFlag = eduarray[c].currentStudyFlag
          certiobj.country = eduarray[c].countryId
          certiobj.countryObj = eduarray[c].country
          certiobj.state = eduarray[c].stateId
          certiobj.stateObj = eduarray[c].state
          certiobj.city =  eduarray[c].cityId
          certiobj.cityObj = eduarray[c].city
          // certiobj.startDate =  new Date(eduarray[c].fromDate).toISOString().split('T')[0]
          certiobj.startDate =  moment(eduarray[c].fromDate).format('YYYY-MM-DD')
          if(eduarray[c].currentStudyFlag == 'Y'){
            certiobj.endDate = ''
          }else{
            // certiobj.endDate = new Date(eduarray[c].toDate).toISOString().split('T')[0]
            certiobj.endDate = moment(eduarray[c].toDate).format('YYYY-MM-DD')
          }
          certiobj.fieldOfStudy = eduarray[c].fieldOfStudy.fieldName
          certiobj.fieldOfStudyId = eduarray[c].fieldOfStudyId
          certiobj.institution = eduarray[c].instituteDetails.instituteName
          certiobj.institutionid = eduarray[c].instituteId
          certiobj.studyStatus =  eduarray[c].currentStudyFlag
          this.certificates.push(certiobj)
        }
        console.log("this.certificates  : ", this.certificates)
      })
    },
    // this will invoke after click on cancel/close button on delete certification confirmation modal
    // clear selected certification index which is meant to be delete
    clearSelectedCertificationsIndex : function() {
      this.selectedCertificatesIndex = ''
    },
    deleteCertification : function() {
      console.log("selected edu index : ", this.selectedCertificatesIndex)
      console.log("deleting record : ", this.certificates[this.selectedCertificatesIndex].id)
      var vm = this;
      htttpuserprofile.delete("userprofile/userEducation/"+this.certificates[this.selectedCertificatesIndex].id)
      .then((response) => {
        console.log("successfully deleted : ", response)
        $('#deleteEduModal').modal('hide')
        vm.$toast.success("Successfully deleted Eductaion")
        this.clearcertificationsObject()
        this.certificates.splice(this.selectedCertificatesIndex, 1);
        // if (index === 0) this.addCertification();
        this.selectedCertificatesIndex = '';
        //clear selected color once updated
        let certisec = document.getElementsByClassName('educat')
        for(var i=0; i < certisec.length; i++){
          certisec[i].style.backgroundColor = "white"
        }
        if(this.certificates.length < 1){
          this.profilePercentage -= 10;
          this.getprofileStrengthLabel()
        }
      }).catch((error) => {
        console.log(error)
        $('#deleteEduModal').modal('hide')
        this.displayAPIerrorModal = true;
      })
    },
    // this will invoke after click on delete button on saved certifications list 
    deleteCertificationModal: function(index) {
      this.selectedCertificatesIndex = index;
      console.log("selected edu index : ", this.selectedCertificatesIndex)
    },
  },
  mounted: function() {
    //set page scroll
    window.scrollTo(0, 0);
    var vm = this;
    console.log("userid in createprofile : ", sessionUtils.getUserId())
    this.currentRoute = this.$route.name;
    let planCardSelected = localStorage.getItem("selectedPlanCard")
    if(planCardSelected) {
      vm.$toast.success("To access the payment screen you have submit the basic information first...")
    }
    // this.userType = localStorage.getItem("userType");
    this.fetchdata();
  },
   computed:{

   },
   beforeDestroy() {
    this.$session.remove('activeElement')
  }

};
</script>
<style scoped>
@import '../css/vue-multiselect.min.css';
@import '../css/vue2-datepicker.css';
/* .experience .exp:nth-child(odd){background-color: #f3f3f3;} */
ul li::marker {
  color: #1f1f1f;
  text-decoration: underline;
  opacity: 0.8;
  font-size: 0px;
  list-style: none !important;
}

.fixing{
position:fixed;
   left:100px;
}

.header {
  position: fixed;
  width: 100%;
  z-index: 3;
  background: #ffffff;
  border-bottom: 2px solid rgba(219, 219, 219,1);
}
.multiselectInput-create {
  font-size: 18px;
  padding: 0 0 0 0;
  display: block;
  width: 100%;
  border: none;
  font-family: "ProximaNova-Regular" !important;
  /* border-bottom: 1px solid #757575; */
}
.input-create {
  font-size: 18px;
  padding: 10px 10px 10px 5px;
  display: block;
  width: 100%;
  border: none;
  border-bottom: 1px solid #757575;
  font-family: "ProximaNova-Regular" !important;
}
.input-create:focus{
/* .input-create:valid { */
  outline: none;
  border-bottom: 1px solid #0078FF;
}
.multiselectInput-create:hover {
  border-bottom: 1px solid #0078FF !important;
}
#LocationDropdown{
  z-index: 3;
}
/* LABEL ======================================= */
.label-create {
  color: #999;
  font-size: 14px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 5px;
  top: 20px;
  font-family: "ProximaNova-Regular" !important;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}

/* active state */
.input-create:focus ~ .label-create,
.input-create:valid ~ .label-create {
  top: -15px;
  font-size: 14px;
  /* color: #0078FF; */
}

#main {
  margin: 0px 0px;
}
.duplicateError{
  color: red;
  text-align: center;
}
#main #faq .card {
  margin-bottom: 30px;
  border: 0;
  border-radius: 10px
}
a{
  white-space: nowrap !important;
}
#main #faq .card .card-header {
  border: 0;
  -webkit-box-shadow: 0 0 20px 0 rgba(213, 213, 213, 0.5);
  box-shadow: 0 0 20px 0 rgba(213, 213, 213, 0.5);
  border-radius: 2px;
  padding: 0;
}
.createsidemenu{
  position: relative;
}
#main #faq .card .card-header .btn-header-link {
  display: block;
  text-align: left;
   background:
rgba(255,255,255,1);

  color: #222;
  padding: 20px;
}

#main #faq .card .card-header .btn-header-link:after {
  content: "\f107";
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  float: right;
}

#main #faq .card .card-header .btn-header-link.collapsed {
  background:
rgba(255,255,255,1);

}

#main #faq .card .card-header .btn-header-link.collapsed:after {
  content: "\f106";
}

#main #faq .card .collapsing {
  background: #ffffff;
  line-height: 30px;
}

#main #faq .card .collapse {
  border: 0;
}

#main #faq .card .collapse.show {
  background: #ffffff;
  line-height: 30px;
  color: #222;
}

.button-create {
  border-radius: 4px;
  background-color: #fdfafa;
  border: 1px solid #fdfafa;
}

.button-create-font {
  /* color: rgb(141, 135, 135); */
  font-family: "Proxima Nova";
  font-size: 16px;
  font-weight: bold;
}
.button-cancel {
  border: 1px solid #1f1f1f;
  opacity: 0.3;
  border-radius: 4px;
}
.countryCodeInput{
  padding-right: 0;
  padding-left: 0;
  margin-top: 8px;
}
.countryCodeInputfield{
  font-size: 15px;
}
.prifixusernameinput{
  padding-right: 0;
  padding-left: 0;
}
.button-cancel1 {
  border: 1px solid #1f1f1f;
  opacity: 0.3;
  border-radius: 20px !important;
  /* transition: border 8s; */
}
.button-cancel1:hover{
  opacity: 1 !important;
}
/* .button-cancel1:hover{
  opacity: 1;
  background: -webkit-linear-gradient(44.51deg, #E6784F 0%, #EA5184 100%);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
  border: 2px solid transparent;
  border-radius: 10px !important;
  -moz-border-image: -moz-linear-gradient(top, #E6784F 0%, #EA5184 100%);
  -webkit-border-image: -webkit-linear-gradient(top, #E6784F 0%, #EA5184 100%);
  border-image: linear-gradient(to bottom, #E6784F 0%, #EA5184 100%);
  border-image-slice: 1;
} */
.backgroundcolorblack{
  color: white !important;
  background: black !important;
}
#exampleFormControlFile2 {
  display: none;
}
.border{
  padding-left: 10px;
}
.mouseoveraction:hover{
	background-color: rgba(161, 166, 179,.2);
  /* margin-left: 3px; */
  margin-right: 10px;
  border-radius: 20px;
}

.button-cancel-font {
  /* opacity: 0.8 !important; */
  font-family: "Proxima Nova";
  font-size: 14px;
  font-weight: 600;
  /* color: #1f1f1f; */
  cursor: pointer;
}
.modaldeletebtn{
  transition : ease-out 0.3s;
	POSITION : relative;
	z-index : 1;
}
.modaldeletebtn::before{
  transition : 0.5s all ease;
	position : absolute;
	top : 0;
	left : 30%;
	right : 30%;
	bottom : 0;
	opacity : 0;
	content : "";
  border-radius: 20px;
  margin-top: -1px;
	background-color :  rgba(29, 27, 27, 0.1);
}
.modaldeletebtn:hover::before{
  transition : 0.5s all ease;
	left : 0;
	right : 0;
	opacity : 1;
	z-index : -1
}
.card-footer {
  background-color: rgba(255,255,255,1)!important;
}

.border-bottom{
  margin-left: 20px;
  margin-right: 20px
}

.img-bgcolor{
  background-color: #A1A6B3;
  opacity:60%
}

ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.border-tab{
  border-left-style: solid;
  border-left-width:4px;
  border-left-color: #0078FF;
}
.addmore {
  cursor: pointer;
  padding: 1px;
  width: 215px;
}
.addmore:hover{
  border-radius: 16px;
  padding: 0px;
  background-color: rgba(161, 166, 179,0.1);
  border: 1px solid rgba(161, 166, 179,.5);
}
.list-Font-color{
  opacity: 0.8;
  color: #1F1F1F;
  font-family: "Proxima Nova";
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
}
.profile-pic {
	position: relative;
	display: inline-block;
}
.profile-border{
  padding: 2px;
  border: 2px solid #ced4da;
  border-radius: 50%;
}
/* .profile-pic:hover .edit {
	display: block;
} */

.edit {
  cursor: pointer;
  width: 25px;
  border: 1px solid #ced4da;
  border-radius: 50%;
	/* padding-top: 7px;
	padding-right: 7px; */
	position: absolute;
	right: 0;
	top: 0;
  margin-top:70%
	/* display: none; */
}
.pageloader {
  width: 7%;
  margin-top: 15%;
  margin-left: 46%;
}
.list-text-color{
  color: #0078FF !important;
  font-family: "Proxima Nova";
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
}

.nav>li>a:focus, .nav>li>a:hover {
        text-decoration: none;
        background-color: transparent !important;
  }

 #main #faq .card .card-header .btn-header-link.collapsed:after {
    content: url("../assets/arrowdown.svg");
 }

#main #faq .card .card-header .btn-header-link:after {
    content: url("../assets/arrow.svg");
    float: right;
}

.list-group-item{
  padding: .25rem 0.25rem;
  border: none;
}
.list-group-item:hover{
  background: rgba(31,31,31,.2) !important;
}
.dropdown-menu{
  display:block;    
  color: black;
  box-shadow: 0px 8px 16px 0px rgba(0,23,56,0.1);
  border: none;
  margin-top: 0px;   
  border-radius: 10px  !important;
}
.searchResults {
  position:absolute; 
  background-color: white; 
  z-index: 50;
  top: 50px;
 
}

.fontsize-20{
  color: #1F1F1F;
  font-family: "Proxima Nova";
  font-size: 20px;
  font-weight: 600;
}

/* .preview {
  max-width:250px;
  max-height:250px;
} */

.modal-height{
  height: 600px;
  /* width: 656px !important; */
  width: 100% !important;
  border-radius: 10px !important;

}
.border-tab-bottom{
    border-bottom-style: solid;
    border-bottom-color: #0078FF;
  }
.modal-body{
  background-color: #000000
}
.modal-delete {
  background-color: white;
  border-radius: .3rem;
  padding-top: 0 !important;
}
.delete-modal{
  border: none;
}
.modal-footer{
  background-color: #ffffff
}
#deleteExpModal{
  margin-top: 15%;
}
#deleteEduModal{
  margin-top: 15%;
}
html,
body,
.grid {
   height: 100%;
  width: 100%;
   /* height: 300px;
  width: 315px;
    margin: -.89px; */
}
.grid {
    /* background-image:
      repeating-linear-gradient(#ccc 0 1px, transparent 1px 100%),
      repeating-linear-gradient(90deg, #ccc 0 1px, transparent 1px 100%); */
    background-size: 81px 81px;
     border-radius: 50%;
     overflow: hidden;
}

.circle{
  height: 300px;
  width: 315px;
  border-radius: 50%;
  border:1px solid white;
}

.photo{
  height: 96px;
  width: 96px;
  background-color: rgba(255,255,255,1);
  border-radius: 50%
}
.knowledgeItem {
  border-radius: 10px;
  font-family: "Proxima Nova";
  cursor: pointer;
}
.zoomControlText {
  color: white;
  font-size:13px
}
.circle-padding{
   /* padding: 100px 185px 136px 171px; */
   padding-left: 15%  !important;
   padding-top: 6%;
   padding-bottom: 6%;
   text-align:center
}

 .input-tag {
     background-color: black!important;
    /* border-radius: 2px; */
    /* border: 1px solid #a5d24a; */
    /* color: #638421; */
    display: inline-block;
    font-size: 13px;
    font-weight: 400;
    /* margin-bottom: 4px; */
    margin-right: 4px;
    padding: 3px;
}
.footer {
  position: fixed;
  bottom: 0;
  z-index: 4;
}
@media only screen and (max-width: 600px){
  .pageloader {
    width: 20%;
    margin-top: 25%;
  }
  /* .exppadding {
    padding-left: 0px !important;
    padding-right: 8px !important;
  }
  .edupadding {
    padding-left: 0px !important;
    padding-right: 8px !important;
  } */
  .locInput {
    padding-left: 0px !important;
    padding-right: 8px !important;
  }
  .profimg {
    width: 210px !important;
  }
  .footer {
    position: fixed;
    bottom: 0;
  }
  .experiences{
    padding-left: 0 !important;
  }
  .mobviewItems {
    font-size: 10px  !important;
    overflow-x: auto;
  }
  /* ul.input-create:valid{
    white-space: nowrap  !important;
    overflow-x: auto !important;
  }
  ul.nav li{
    display: inline-block !important;
    float: none !important;
  } */
  a.list-Font-color{
    white-space: nowrap !important;
  }
  .list-Font-color{
    opacity: 0.8;
  color: #1F1F1F;
  font-family: "Proxima Nova";
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  white-space: nowrap;
  }
  .circle-padding{
   /* padding: 100px 185px 136px 171px; */
    padding-left: 7%  !important;
    padding-top: 6%;
    text-align:center
  }
  .modal-height{
    margin-top: 20%;
    width: 100% !important;
  }
}
@media screen and (min-width: 800px) {
  .createsidemenu{
    position: fixed;
  }
  .centercard{
    margin-left: 25%;
  }
}
@media screen and (max-width: 1020px) and (min-width: 767px) {
  .main-card {
    padding-left: 5% !important;
    padding-right: 5% !important;
  }
  .mobviewItems{
    overflow: auto;
  }
}
@media screen and (max-width: 768px) and (min-width: 600px){
  .list-Font-color{
    opacity: 0.8;
    color: #1F1F1F;
    font-family: "Proxima Nova";
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0;
    white-space: nowrap;
  }
  .footer {
    position: fixed;
    bottom: 0;
  }
}

</style>
